import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CloseButton,
  Flex,
  FormLabel,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SimpleGrid,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterListIcon from "@mui/icons-material/FilterList";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import SpinnerIcon from "@rsuite/icons/legacy/Spinner";
import CheckFilter from "../../components/CheckFilter/CheckFilter";
import NotFound from "assets/svg/not-found.svg";
import Searchicon from "assets/svg/search-icon.svg";
import axios from "axios";
import CommonSubmissionFile from "components/CommonSubmissionFile/CommonSubmissionFile";
import JobDescriptionEditor from "components/Commoncomponent/JobDescriptionEditor/JobDescriptionEditor";
import NoteModel from "components/Commoncomponent/Note/NoteModel";
import NoteSubmissionModel from "components/Commoncomponent/Note/NoteSubmissionModel";
import CustomizeColumns from "components/CustomizeColumns/CustomizeColumns";
import EditSubmissionStatusModel from "components/EditSubmissionStatusModel/EditSubmissionStatusModel";
import SearchCandidateModel from "components/SearchCandidateModel/SearchCandidateModel";
import SearchJobModel from "components/SearchJobModel/SearchJobModel";
import { City, Country, State } from "country-state-city";
import * as FileSaver from "file-saver";
import { useFormik } from "formik";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { Modal, OverlayTrigger, Popover } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ListGroup from "react-bootstrap/ListGroup";
import Row from "react-bootstrap/Row";
import { useCookies } from "react-cookie";
import { FiSearch } from "react-icons/fi";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useParams } from "react-router";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckPicker from "rsuite/CheckPicker";
import * as Yup from "yup";
import {
  getAllCities,
  getAllStates,
  getJobNotes,
  getOptionById,
  handleGenerateJD,
  userActivity,
} from "../../Utils";
import config from "../../config";
import {
  defaultSubmHeaderOrders,
  submCandidateHeaderShow,
} from "../../constant";
import ComposeMailForm from "./ComposeMailForm";
import { default as Loadar, default as Loader } from "./Loader";
import Submissionform from "./Submissionform";
import "./org.css";
import InputTextSearchBox from "components/InputTextSearchBox/InputTextSearchBox";
import { useSelector } from "react-redux";
import CommonPagination from "../../components/CommonPagination/CommonPagination";
import  FileViewer  from "react-file-viewer";
import JobAddModal from "../../components/Commoncomponent/JobAddModal";
import DeleteModal from "components/Commoncomponent/DeleteModal";
import ResumePreviewModal from "components/Commoncomponent/ResumePreviewModal";
const addJobs = (isEdit) =>
  Yup.object().shape({
    jobtitle: Yup.string().required("Please enter job title"),

    country: Yup.string().required("Please select country"),
    targetdate: Yup.string().required("Please select target date"),
    status: Yup.string().required("Please select status"),
    jobtype: Yup.string().required("Please select Job type"),
    city: Yup.string().required("Please select city"),
    state: Yup.string().required("Please select state"),
    remotestatus: Yup.string().required("Please select remort status"),
    jobdescription: Yup.string().required("Please add job description"),
    experience: Yup.string().required("Please select experience"),
    clientId: Yup.string(),

    numberofPosition: Yup.number().required(
      "Please add number of poistion for job"
    ),
    skill: Yup.string().required("Please add required skill for job"),
    question: Yup.string(),
    placementType: Yup.string().required("Please select placement type"),
    clientpayType: Yup.string().required("Please select clinent pay type"),
    ctc: Yup.string().required("Please add ctc"),
    onetimeplacementbillType: Yup.string(),
    onetimeplacementbillValue: Yup.number(),
     team:  Yup.string(),
    teamleader: Yup.string(),
    recruiter: Yup.string(),
    clientContactName: Yup.string(),
    email: Yup.string(),
    industry: Yup.string().required("Please select industry"),
    ownerPhone: Yup.string().required("Please add phone number"),
    jobAddress:Yup.string(),
    pincode: Yup.number(),
  });

const EditContact = Yup.object().shape({
  accountName: Yup.string().required("Select Account Name "),

  accountOwnerName: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Account Owner Name Is Required"),
  email: Yup.string().email("Invalid Email").required("Email Is Required"),

  phone: Yup.string().required("Mobile Number Is Required"),

  designation: Yup.string().required("Owner Designation Required"),
  department: Yup.string().required("Please Enter A Department"),
  street: Yup.string().required("Please Provid Street Name "),
  pincode: Yup.string().required("Please Enter Pincode"),
  externalphone: Yup.string(),
  country: Yup.string().required("Please Select Country"),
  state: Yup.string().required("Please Select State"),
  city: Yup.string().required("Please Select City"),
});

function Contactview() {
  const history = useHistory();
  const { userNames: reduxUserNames } = useSelector(
    (state) => state.usersSlice
  );
  const {userNames} =useSelector((state)=>state.usersSlice);
  const [searchSourceData, setSearchSourceData] = useState([]);
  const [isFilterActiveSourceSearch, setIsFilterActiveSourceSearch] =
    useState(false);
  const handleGoBack = () => {
    history?.goBack();
  };
  const [totalPages,setTotalPages]=useState(1)
  const [totalClientPages,setTotalClientsPages]=useState(1)
  const { id } = useParams();
  const [cookie] = useCookies(["role", "id", "token"]);
  const candidate_ownerName = localStorage?.getItem("candidate_ownerName");
  const userId = cookie.id;
    const [jobBranch, setJobBranch] = useState(null);
 const getCurrentLoggedInUserName = getOptionById(userId,userNames);
  const userRole = cookie?.role;
  const [note, setNote] = useState({});
  const [getnotes, setGetNotes] = useState([]);
  const [searchKeywordCity, setSearchKeywordCity] = useState("");
  const [searchNote, setSearchNote] = useState("");
  const [notesLoading, setNotesLoading] = useState(false);
  const [jobNote, setJobNote] = useState(false);
  const [jobLoading, setJobLoading] = useState(false);
  const [selectedTeamLeader, setSelectedTeamLeader] = useState(null);
  const [selectedRecruiter, setSelectedRecruiter] = useState(null);
  const [selectedAccountManager, setSelectedAccountManager] = useState(null);
  const [searchCandidateOwnerName, setSearchCandidateOwnerName] =
    useState(null);
  const handleJobNoteShow = () => {
    setJobNote(true);
  };
  const handleJobNoteClose = () => {
    setJobNote(false);
  };
  const [selectedOption, setSelectedOption] = useState(null);
  // const [selectedTeamLeader, setSelectedTeamLeader] = useState(null);
  const [selectedTeamD,setSelectedTeamD]=useState([])
  const [recruiters,setRecruiters]=useState([])
  const [alluserTeams, setAlluserTeams]=useState([])
  const [selectedClientContactName, setSelectedClientContactName] =
    useState(null);
  const [Id, setId] = useState("");
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({
    accountId: "",
    accountName: "",
    clientemail: "",
    accountOwnerName: "",
    department: "",
    designation: "",
    email: "",
    phone: "",
    externalphone: "",
    street: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
  });
  const [isFilterActiveBranch, setIsFilterActiveBranch] = useState(false);
  const [isFilterActiveTabJobBranch, setIsFilterActiveTabJobBranch] = useState(false);
    const [searchBranch, setSearchBranch] = useState([]);
    const [searchJobTabBranch, setSearchJobTabBranch] = useState([]);
  const [jdLoading, setJdLoading] = useState(false);
  const [displaycontact, setDisplayContact] = useState([]);
  const [AccountContactId, setAccountContactId] = useState("");
  const [AccountContactName, setAccountContactName] = useState("");
  const [searchteamleader, setSearchTeamleader] = useState([]);
  const [jobScreeningId, setJobScreeningId] = useState([]);
  const [jobSearchActiveField, setJobSearchActiveField] = useState({
    name: "",
    value: "",
  });
  const [activeField, setActiveField] = useState({ name: "", value: "" });

  const [clientJobs, setClientJobs] = useState([]);
  const [displayClientJobs, setDisplayClientJobs] = useState([]);
  const [applicationStatus, setApplicationStatus] = useState([]);
  const [searchSubmissionId, setSearchSubmissionId] = useState([]);
  const [isFilterActiveSubmissionId,setIsFilterActiveSubmissionId]=useState(false)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [contactPage, setContactPage] = useState(0);
  const [rowsPerContactPage, setRowsPerContactPage] = useState(10);

  const [selectedCountry, setSelectedCountry] = useState({
    name: "India",
    isoCode: "IN",
  });
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const [ViewPost, SetPostShow] = useState(false);
  const [ViewEdit, SetEditShow] = useState(false);
  const [deleteJob, setDeleteJob] = useState(false);
  const [jobid, setJobId] = useState("");
  const [ViewEditStatus, SetEditStatusShow] = useState(false);
  const [clientBranch,setClientBranch]=useState([]);
  const [searchAllfields, setSearchAllfields] = useState("");
  const [jobpost, setJobpost] = useState({
    jobtitle: "",
    customer: "",
    country: "India",
    targetdate: "",
    recruiter: "",
    teamleader: "",
    status: "",
    jobtype: "",
    city: "",
    state: "",
    remotestatus: "",
    accountmanager: "",
    jobdescription: "",
    experience: "",
    clientContactName: "",
    accountName: "",
    email: "",
    numberofPosition: "",
    skill: "",
    question: "",
    placementType: "",
    clientpayType: "",
    ctc: "",
    onetimeplacementbillType: "",
    onetimeplacementbillValue: "",
  });

  const [appliedJob, setAppliedJob] = useState([]);
  const [displayAppliedJob, setDisplayAppliedJob] = useState([]);
  const [deleteSubmission, setDeleteSubmission] = useState(false);
  const [submissionid, setSubmissionId] = useState("");
  const [editSubmission, SetEditSubmission] = useState(false);
  const [editSubmissionStatus, SetEditSubmissionStatus] = useState(false);
  const [submission, setSubmission] = useState({
    status: "Client - Submitted",
    jobId: "",
    clientId: "",
    candidateId: "",
    Questions: "",
    email: "",
    clientemail: "",
    currentCandidateCTCType: "",
    currentCandidateCTC: "",
    expectedCandidateCTCType: "",
    expectedCandidateCTC: "",
    noticePeriod: "",
    relevantExperiance: "",
    availability: "",
    engagement: "",
    locationPreference: "",
    submitterName: "",
    QnA: [],
    file: "",
    fileName: "",
    filePath: "",
  });
  const [pipelinedCandidates, setPipelinedCandidates] = useState([]);
  const [interviewedCandidates, setInterviewedCandidates] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [joinedCandidates, setJoinedCandidates] = useState([]);
  const [onboardedCandidates, setOnboardedCandidates] = useState([]);
  const [activeJobs, setActiveJobs] = useState([]);
  const [deactiveJobs, setDeactiveJobs] = useState([]);

  const [searchjobtitle, setSearchJobtitle] = useState("");
  const [searchaccountmanager, setSearchAccountmanager] = useState([]);
  const [searchrecruiter, setSearchRecruiter] = useState([]);
  const [searchJobOwner, setSearchJobOwner] = useState([]);
  const [searchcity, setSearchCity] = useState([]);
  const [searchJobBranch,setSearchJobBranch]=useState([])
  const [searchstate, setSearchState] = useState([]);
  const [searchskill, setSearchSkill] = useState("");

  const [selectedJobdate, setSelectedJobDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchSubmissionDate, setSearchSubmissionDate] = useState([]);
  const [searchSubmissionUpdateDate, setSearchSubmissionUpdateDate] = useState(
    []
  );
  const [isFilterActiveJclient, setIsFilterActiveJclient] = useState(false);
  const [isFilterActiveTlead, setIsFilterActiveTlead] = useState(false);
  const [isFilterActiveJobt, setIsFilterActiveJobt] = useState(false);
  const [isFilterActiveCity, setIsFilterActiveCity] = useState(false);
  const [isFilterActiveState, setIsFilterActiveState] = useState(false);
  const [isFilterActiveActMang, setIsFilterActiveActMang] = useState(false);
  const [isFilterActiveContactPerson, setIsFilterActiveContactPerson] =
    useState(false);
  const [isFilterActiveRecruiter, setIsFilterActiveRecruiter] = useState(false);
  const [isFilterActiveSkill, setIsFilterActiveSkill] = useState(false);
  const [isFilterActiveStatus, setIsFilterActiveStatus] = useState(false);
  const [isFilterActiveJdate, setIsFilterActiveJdate] = useState(false);
  const [isFilterActiveDate, setIsFilterActiveDate] = useState(false);
  const [isFilterJobActiveOwner, setIsFilterJobActiveOwner] = useState(false);

  const [submissionPreview, SetSubmissionPreview] = useState(false);
  const [objectURL, setObjectURL] = useState("");

  const [ViewSendMail, SetSendMailShow] = useState(false);
  const [ViewSendMailSub, SetSendMailShowSub] = useState(false);
  const [checked, SetIschecked] = useState([]);
  const [toemail, SetToemail] = useState("");
  const [ccemail, SetCcemail] = useState("");
  const [bccemail, SetBccemail] = useState("");
  const [subject, SetSubject] = useState("");
  const [mailMessage, SetMailMessage] = useState("");

  const [contactId, setContactId] = useState("");
  const [editContact, setEditContact] = useState(false);

  const [candidates, setCandidates] = useState([]);
  const [searchjob, setSearchJob] = useState("");
  const [searchcandidate, setSearchcandidate] = useState("");
  const [searchJob, SetSearchJob] = useState(false);
  const [searchCandidateModelShow, setSearchCandidateModelShow] =
    useState(false);
  const [submitSubmission, SetSubmitSubmission] = useState(false);
  const [jobtitle, Setjobtitle] = useState([]);
  const [candidatename, Setcandidatename] = useState([]);
  const [submissionpage, setSubmissionPage] = useState(0);
  const [rowsPerSubmissionPage, setRowsPerSubmissionPage] = useState(10);
  const [searchJobId,setSearchJobId] =useState("")
  const [isFilterActiveJobId,setIsFilterActiveJobId]=useState(false)
 
  const [candidatesubmissionpage, setCandidateSubmissionPage] = useState(0);
  const [rowsPerCandidateSubmissionPage, setRowsPerCandidateSubmissionPage] =
    useState(10);

  const [searchCandidateName, setSearchCandidateName] = useState("");
  const [searchCandidateDesignation, setSearchCandidateDesignation] =
    useState("");
  const [searchCandidateCity, setSearchCandidateCity] = useState("");
  const [candidateSearchActiveField, setCandidateSearchActiveField] = useState({
    name: "",
    value: "",
  });
  const [searchCandidateLoading, setSearchCandidateLoading] = useState(false);

  const [defaultCities, setDefaultCities] = useState([]);
  const [defaultStates, setDefaultStates] = useState([]);

  const [popoverVisible, setPopoverVisible] = useState({});
  // Close filter modal popover
  const handlePopOverClose = (key, visibility) => {
    const newPopoverVisible = key
      ? { ...popoverVisible, [key]: visibility }
      : {};
    setPopoverVisible(newPopoverVisible);
  };
  const [popoverVisibleSubmission, setPopoverVisibleSubmission] = useState({});
  const handlePopOverCloseSubmission = (key, visibility) => {
    const newPopoverVisible = key ? { [key]: visibility } : {};
    setPopoverVisibleSubmission(newPopoverVisible);
  };
  const popOverConfig = useCallback(
    (key) => {
      return {
        trigger: "click",
        placement: "auto",
        rootClose: true,
        show: !!popoverVisible?.[key],
        onToggle: (isShow) => handlePopOverClose(key, isShow),
      };
    },
    [popoverVisible]
  );

  const handleChangeSubmissionPage = (event, newSubmissionPage) => {
    setSubmissionPage(newSubmissionPage);
    if (searchAllfields.length !== 0 || jobSearchActiveField.value !== "") {
      handleFilterAllFieldStep(
        jobSearchActiveField.name !== ""
          ? jobSearchActiveField.value
          : searchAllfields,
        newSubmissionPage,
        rowsPerSubmissionPage,
        jobSearchActiveField.name
      );
    } else {
      handleFilterAllFieldStep(
        "",
        newSubmissionPage,
        rowsPerSubmissionPage,
        contact.accountId,
        contact?.accountOwnerName
      );
    }
  };
  const handleChangeRowsPerSubmissionPage = (event) => {
    setRowsPerSubmissionPage(+event.target.value);
    setSubmissionPage(0);
    if (searchAllfields.length !== 0 || jobSearchActiveField.value !== "") {
      handleFilterAllFieldStep(
        jobSearchActiveField.name !== ""
          ? jobSearchActiveField.value
          : searchAllfields,
        0,
        +event.target.value,
        jobSearchActiveField.name
      );
    } else {
      handleFilterAllFieldStep(
        "",
        0,
        +event.target.value,
      );
    }
  };

  const handleChangeCandidateSubmissionPage = (
    event,
    newCandidateSubmissionPage
  ) => {
    setCandidateSubmissionPage(newCandidateSubmissionPage);
    if (
      searchcandidate.length !== 0 ||
      (candidateSearchActiveField.name !== "" &&
        candidateSearchActiveField.value !== "")
    ) {
      filterCandidateData(
        candidateSearchActiveField.value,
        newCandidateSubmissionPage,
        rowsPerCandidateSubmissionPage,
        candidateSearchActiveField.name
      );
    } else {
      filterCandidateData(
        "",
        newCandidateSubmissionPage,
        rowsPerCandidateSubmissionPage
      );
    }
  };
  const handleChangeRowsPerCandidateSubmissionPage = (event) => {
    setRowsPerCandidateSubmissionPage(+event.target.value);
    setCandidateSubmissionPage(0);
    if (
      searchcandidate.length !== 0 ||
      (candidateSearchActiveField.name !== "" &&
        candidateSearchActiveField.value !== "")
    ) {
      filterCandidateData(
        candidateSearchActiveField.value,
        0,
        +event.target.value,
        candidateSearchActiveField.name
      );
    } else {
      filterCandidateData("",0, +event.target.value);
    }
  };
  const handleEditContactShow = () => {
    setEditContact(true);
  };
  const handleEditContactClose = () => {
    setEditContact(false);
    editFormik.resetForm();
  };

  const handleSendMailShow = () => {
    SetSendMailShow(true);
  };
  const handleSendMailClose = () => {
    SetSendMailShow(false);
    SetToemail("");
    SetCcemail("");
    SetBccemail("");
    SetSubject("");
    SetMailMessage("");
  };
  const handleSendMailSubClose = () => {
    SetSendMailShowSub(false);
  };

  const handleDeleteJobShow = () => {
    setDeleteJob(true);
  };
  const handleDeleteJobClose = () => {
    setDeleteJob(false);
    setJobpost({
      jobtitle: "",
      customer: "",
      country: "India",
      targetdate: "",
      recruiter: "",
      teamleader: "",
      status: "",
      customertype: "",
      jobtype: "",
      city: "",
      state: "",
      remotestatus: "",
      accountmanager: "",
      jobdescription: "",
      experience: "",
      clientId: "",
      clientContactName: "",
      accountName: "",
      email: "",
      numberofPosition: "",
      skill: "",
      question: "",
      placementType: "",
      clientpayType: "",
      ctc: "",
      onetimeplacementbillType: "",
      onetimeplacementbillValue: "",
    });
  };
  const handleDeleteSubmissionShow = () => {
    setDeleteSubmission(true);
  };
  const [parseAge, setParseAge] = useState("");
  const [parsePercentage, setParsePercentage] = useState("");
  const [matchingSkills, setMatchingSkills] = useState([]);
  const [missingSkills, setMissingSkills] = useState([]);
  const [ParsedSkills, setParsedSkills] = useState([]);
  const [loadingResumeScreening, setLoadingResumeScreening] = useState(false);
  const [parseResumeConclusion, setparseResumeConclusion] = useState("");
  const parts = location.pathname.split("/");
  const [uniqueCandidateId,setUniqueCandidateId] = useState("")
  const router = parts[parts.length - 1];
  const handleDeleteSubmissionClose = () => {
    setDeleteSubmission(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "Client - Submitted",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
    });
  };
  const [oldJobId, setOldJobId] = useState("");
  const [candidateNote, setCandidateNote] = useState(false);
  const [ViewSubmheaderOrders, setViewSubmheaderOrders] = useState(false);

  const [submheaderOrders, setSubmHeaderOrders] = useState(
    JSON.parse(localStorage.getItem("submheaderOrders")) ||
      defaultSubmHeaderOrders.filter(
        (header) => submCandidateHeaderShow[header]
      )
  );
  const [displaySubmheaderOrders, setDisplaySubmheaderOrders] = useState(
    defaultSubmHeaderOrders
  );
  const [defaultDisplaySubmHeaderOrders, setDefaultDisplaySubmHeaderOrders] =
    useState(
      JSON.parse(localStorage.getItem("defaultDisplaySubmHeaderOrders")) ||
        submCandidateHeaderShow
    );
  const handleSubmHeaderOrdersshow = () => {
    setViewSubmheaderOrders(true);
  };
  const handleSubmHeaderOrdersClose = () => {
    setViewSubmheaderOrders(false);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(displaySubmheaderOrders);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setDisplaySubmheaderOrders(items);
  };

  const handleApplyClick = () => {
    const temp = Object.keys(defaultDisplaySubmHeaderOrders).filter(
      (key) => defaultDisplaySubmHeaderOrders[key]
    );
    const main = displaySubmheaderOrders.filter((key) => temp.includes(key));
    setSubmHeaderOrders(main);
    toast.success("Columns change successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    handleSubmHeaderOrdersClose();
  };
  const handleCheckboxChange = (key, isChecked) => {
    const temp = JSON.parse(JSON.stringify(defaultDisplaySubmHeaderOrders));
    temp[key] = isChecked;
    setDefaultDisplaySubmHeaderOrders(temp);
  };

  const handleCandidateNoteShow = () => {
    setCandidateNote(true);
  };
  const handleCandidateNoteClose = () => {
    setCandidateNote(false);
  };

  const getCandidatNotes = async (id) => {
    try {
      setNotesLoading(true);
      if (id) {
        const response = await axios.get(
          `${config?.apiUrl}/api/get_Candidate_Note/${id}`
        );
        const notedata = response.data.data;
        setGetNotes(notedata);
        setNotesLoading(false);
      } else {
        setNotesLoading(false);
      }
    } catch (error) {
      setNotesLoading(false);
      toast.error(
        error?.message ||
          "Something happened wrong, please try again after sometime.",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
  };
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  const filename = "Submissions";

  const exportSubmissions = (submissions, filename) => {
    // Check if any submission is selected
    if (checked.length === 0) {
      toast.error("Please select at least one user to export information", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    // Define file properties
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    // Filter submissions based on checked IDs
    const filteredSubmissions = submissions
      .filter((candidate) =>
        checked.some((check) => check.id === candidate._id)
      )
      .map((candidate) => {
        const filteredVal = {};

        displaySubmheaderOrders.forEach((field) => {
          const value = defaultDisplaySubmHeaderOrders[field];
          if (value) {
            switch (field) {
              case "email":
                filteredVal["Email"] = candidate.candidateId?.email;
                break;
              case "clientemail":
                filteredVal["Client Email"] = candidate.clientId?.email;
                break;
              case "firstName":
                filteredVal["First Name"] = candidate.candidateId?.firstName;
                break;
              case "lastName":
                filteredVal["Last Name"] = candidate.candidateId?.lastName;
                break;
              case "client":
                filteredVal["Client"] = candidate.clientId?.accountName;
                break;
              case "owner_name":
                filteredVal["Owner Name"] = candidate?.candidate_ownerName;
                break;
              case "city":
                filteredVal["City"] = candidate.candidateId?.city;
                break;
              case "state":
                filteredVal["State"] = candidate.candidateId?.state;
                break;
              case "phone":
                filteredVal["Phone"] = candidate.candidateId?.phone;
                break;
              case "DOB":
                filteredVal["Date of Birth"] =
                  candidate.candidateId?.dateofBirth;
                break;
              case "address":
                filteredVal["Address"] = candidate.candidateId?.address;
                break;
              case "aadharcardnumber":
                filteredVal["Aadhar Number"] =
                  candidate.candidateId?.AadharcardNumber;
                break;
              case "pancardnumber":
                filteredVal["PAN Number"] =
                  candidate.candidateId?.PancardNumber;
                break;
              case "designation":
                filteredVal["Designation"] = candidate.candidateId?.designation;
                break;
              case "jobtitle":
                filteredVal["Job Title"] = candidate.jobId?.jobtitle;
                break;
              case "workExperience":
                filteredVal["Comapny name"] =
                  candidate.candidateId &&
                  (candidate.candidateId.workExperience.length === 0
                    ? "N/A"
                    : candidate.candidateId.workExperience
                        .map((exp) => ({
                          ...exp,
                          startDate: exp.startDate
                            ? new Date(exp.startDate)
                            : null,
                          endDate: exp.endDate
                            ? exp.endDate.toLowerCase() === "present"
                              ? new Date()
                              : new Date(exp.endDate)
                            : exp.startDate,
                        }))
                        .sort((a, b) => (b.endDate || 0) - (a.endDate || 0))
                        .slice(0, 1)
                        .map((latestExperience, index) => {
                          return latestExperience?.companyname;
                        })[0]);
                break;
              case "educationDetails":
                filteredVal["Education"] =
                  candidate.candidateId &&
                  (candidate?.candidateId?.educationDetails.length === 0
                    ? "N/A"
                    : candidate.candidateId?.educationDetails
                        .map((edu) => ({
                          ...edu,
                          startDate: edu.startDate
                            ? new Date(
                                edu.startDate.replace(
                                  /(\d{2})\/(\d{2})\/(\d{4})/,
                                  "$2/$1/$3"
                                )
                              )
                            : null,
                          endDate: edu.endDate
                            ? new Date(
                                edu.endDate.replace(
                                  /(\d{2})\/(\d{2})\/(\d{4})/,
                                  "$2/$1/$3"
                                )
                              )
                            : null,
                        }))
                        .sort(
                          (a, b) =>
                            (b.endDate || new Date(0)) -
                            (a.endDate || new Date(0))
                        )
                        .slice(0, 1)
                        .map((latestDegree, index) => {
                          return latestDegree?.degree;
                        })[0]);
                break;
              case "experience":
                filteredVal["Experience"] = candidate.candidateId?.experiance;
                break;
              case "gender":
                filteredVal["Gender"] = candidate.candidateId?.gender;
                break;
              case "fullName":
                filteredVal["Full Name"] =
                  `${candidate.candidateId?.firstName} ${candidate.candidateId?.lastName}`;
                break;
              case "currentCandidateCTCType":
                filteredVal["Current CTC Type"] =
                  candidate.currentCandidateCTCType;
                break;
              case "currentCandidateCTC":
                filteredVal["Current CTC"] = candidate.currentCandidateCTC;
                break;
              case "expectedCandidateCTCType":
                filteredVal["Expected CTC Type"] =
                  candidate.expectedCandidateCTCType;
                break;
              case "expectedCandidateCTC":
                filteredVal["Expected CTC"] = candidate.expectedCandidateCTC;
                break;
              case "status":
                filteredVal["Status"] = candidate.status;
                break;
              case "submission_at":
                // Assuming candidate?.created_at contains the ISO 8601 formatted date string
                let isoDate = candidate?.created_at;
                if (isoDate) {
                  let date = new Date(isoDate);
                  let day = date.getUTCDate().toString().padStart(2, "0");
                  let month = (date.getUTCMonth() + 1)
                    .toString()
                    .padStart(2, "0");
                  let year = date.getUTCFullYear();
                  let formattedDate = `${day}-${month}-${year}`;
                  filteredVal["Submission date"] = formattedDate;
                }
                break;

              default:
                filteredVal[field] = candidate[field];
            }
          }
        });

        delete filteredVal.Questions;
        delete filteredVal.QnA;

        return filteredVal;
      });

    const ws = XLSX.utils.json_to_sheet(filteredSubmissions);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename + fileExtension);
    const activityOn = `Download excel from submission number of download is ${filteredSubmissions?.length}`;
    const activityDo = `Download excel`;
    const component = "contact";
    const reData ={
      name:candidate_ownerName,
      id:userId,  
      action:"downloadTemplate",
      type:"candidate",
      ext:"exl"
    }
    userActivity(
      candidate_ownerName,
      userId,
      component,
      activityDo,
      activityOn,
      userRole,
      reData
    );
    handleCloseModal();
  };

  const saveFile = (e) => {
    setSubmission({
      ...submission,
      fileName: e.target.files[0].name,
      filePath: e.target.files[0].path,
      file: e.target.files[0],
    });
  };
  const [contactOldName, setContactOldName] = useState("");
  // EDIT CONTACT FORM
  const editFormikContact = useFormik({
    initialValues: {
      accountName: "",
      accountOwnerName: "",
      department: "",
      designation: "",
      email: "",
      phone: "",
      externalphone: "",
      street: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
    validationSchema: EditContact,
    onSubmit: async (data) => {
      const url = `${config?.apiUrl}/api/update_Contact/${contactId}`;
      const Credentials = {
        accountName: data.accountName,
        accountOwnerName: data.accountOwnerName,
        department: data.department,
        designation: data.designation,
        email: data.email,
        phone: data.phone,
        externalphone: data.externalphone,
        street: data.street,
        country: data.country,
        state: data.state,
        city: data.city,
        pincode: data.pincode,
        countryCode: data?.countryCode || selectedState?.countryCode || "IN",
        stateCode: data?.stateCode || selectedState?.isoCode,
        modified_by: userId || "",
      };

      await axios
        .put(url, Credentials)
        .then(async (response) => {
          toast.success(response.data.msg, {
            position: toast.POSITION.TOP_RIGHT,
          });
          const data = response?.data?.data;
          const activityOn = `Contact ${data?.accountOwnerName} has been updated `;
          const activityDo = "Update Contact";
          const component = "contact";
          const reData ={
            name:data?.accountOwnerName,
            id:contactId,
            action:'editContact',
            type:'contact',
            note:null,
          }
          userActivity(
            candidate_ownerName,
            userId,
            component,
            activityDo,
            activityOn,
            userRole,
            reData
          );

          try {
            if (data?.accountOwnerName != contactOldName) {
              const jobupdateurl = `${config?.apiUrl}/api/update_submitterName/${data?.accountId}`;
              const updateData = {
                oldClientConatctName: contactOldName,
                newClientConatctName: data?.accountOwnerName,
              };

              await axios.put(jobupdateurl, updateData).then((resp) => {});
            }
          } catch (error) {
            console.error("Error editContact:", error);
          }

          handleEditContactClose();
          getContact(id);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.msg || "Please check details", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    },
  });
  const getConatct = (val) => {
    editFormikContact.setValues({
      accountId: val.accountId,
      accountName: val.accountName,
      clientemail: val.clientemail,
      accountOwnerName: val.accountOwnerName,
      department: val.department,
      designation: val.designation,
      email: val.email,
      phone: val.phone,
      externalphone: val.externalphone,
      street: val.street,
      country: val.country,
      state: val.state,
      city: val.city,
      pincode: val.pincode,
    });
    setContactOldName(val?.accountOwnerName);

    setSelectedState({
      name: val?.state,
      countryCode: val?.countryCode,
      isoCode: val?.stateCode,
    });
    setSelectedCity({
      name: val?.city,
      countryCode: val?.countryCode,
      isoCode: val?.stateCode,
    });
  };

  const handleSubmissionPreviewShow = () => {
    SetSubmissionPreview(true);
  };
  const handleSubmissionPreviewClose = () => {
    SetSubmissionPreview(false);
    setObjectURL("");
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "Client - Submitted",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
    });
  };

  const handleInputs = (e) => {
    let name, value;
    name = e?.target?.name;
    value = e?.target?.value;
    if (name && value) {
      setSubmission({ ...submission, [name]: value });
      setJobpost({ ...jobpost, [name]: value });
    } else {
      setSubmission({});
      setJobpost({});
    }
  };

  const handlePostShow = () => {
    SetPostShow(true);
  };
  const handlePostClose = () => {
    formik.resetForm();
    SetPostShow(false);
    setSelectedTeamLeader(null);
    setSelectedRecruiter(null);
    setSelectedAccountManager(null);
    setJobpost({
      jobtitle: "",
      customer: "",
      country: "",
      targetdate: "",
      recruiter: "",
      teamleader: "",
      status: "",
      customertype: "",
      jobtype: "",
      city: "",
      state: "",
      remotestatus: "",
      accountmanager: "",
      jobdescription: "",
      experience: "",
      clientId: "",
      clientContactName: "",
      accountName: "",
      email: "",
      numberofPosition: "",
      skill: "",
      question: "",
      placementType: "",
      clientpayType: "",
      ctc: "",
      onetimeplacementbillType: "",
      onetimeplacementbillValue: "",
    });
    setSelectedCountry({
      name: "India",
      isoCode: "IN",
    });
    setSelectedState("");
    setSelectedCity("");
  };

  const handleEditShow = () => {
    SetEditShow(true);
  };
  const handleEditClose = () => {
    editFormik.resetForm();
    SetEditShow(false);
    setSelectedTeamLeader(null);
    setSelectedRecruiter(null);
    setSelectedAccountManager(null);
    setJobId("");
    setJobpost({
      jobtitle: "",
      customer: "",
      country: "",
      targetdate: "",
      recruiter: "",
      teamleader: "",
      status: "",
      customertype: "",
      jobtype: "",
      city: "",
      state: "",
      remotestatus: "",
      accountmanager: "",
      jobdescription: "",
      experience: "",
      clientId: "",
      clientContactName: "",
      accountName: "",
      email: "",
      numberofPosition: "",
      skill: "",
      question: "",
      placementType: "",
      clientpayType: "",
      ctc: "",
      onetimeplacementbillType: "",
      onetimeplacementbillValue: "",
    });
    setSelectedCountry({
      name: "India",
      isoCode: "IN",
    });
    setSelectedState("");
    setSelectedCity("");
  };

  const handleEditStatusShow = () => {
    SetEditStatusShow(true);
  };
  const handleEditStatusClose = () => {
    SetEditStatusShow(false);
    setJobId("");
    setJobpost({
      jobtitle: "",
      customer: "",
      country: "",
      targetdate: "",
      recruiter: "",
      teamleader: "",
      status: "",
      customertype: "",
      jobtype: "",
      city: "",
      state: "",
      remotestatus: "",
      accountmanager: "",
      jobdescription: "",
      experience: "",
      clientId: "",
      clientContactName: "",
      accountName: "",
      email: "",
      numberofPosition: "",
      skill: "",
      question: "",
      placementType: "",
      clientpayType: "",
      ctc: "",
      onetimeplacementbillType: "",
      onetimeplacementbillValue: "",
    });
    setSelectedCountry({
      name: "India",
      isoCode: "IN",
    });
    setSelectedState("");
    setSelectedCity("");
  };

  const handleCreateSubmission = () => {
    filterCandidateData("",candidatesubmissionpage, rowsPerCandidateSubmissionPage);
    SetSearchJob(true);
    handleFilterAllFieldStep(
      "",
      0,
      10,
    );
  };
  const handleCreateSubmissionClose = () => {
    SetSearchJob(false);
    handleFilterAllFieldStep("",0, 10);
    clearJobFilter();
  };

  const handleSearchCandidateShow = () => {
    setSearchCandidateModelShow(true);
  };
  const handleSearchCandidateClose = () => {
    setSearchCandidateModelShow(false);
  };

  const handleSubmitSubmissionShow = () => {
    SetSubmitSubmission(true);
  };
  const handleSubmitSubmissionClose = () => {
    SetSubmitSubmission(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "Client - Submitted",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
    });
    setId("");
  };

  const handleEditSubmissionShow = () => {
    SetEditSubmission(true);
    SetSubmitSubmission(true);
    // setId(submission?._id);
  };

  const handleEditSubmissionStatusShow = () => {
    SetEditSubmissionStatus(true);
  };
  const handleEditSubmissionStatusClose = () => {
    SetEditSubmissionStatus(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "Client - Submitted",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
    });
  };

const getAllUserTeams = async () => {
      await axios
        .get(`${config?.apiUrl}/api/get_All_userTeams`,{
          headers: {
          Authorization: `Bearer ${cookie.token}`,
          "Content-Type": "application/json",
        },
        })
        .then((response) => {
          const statusdata = response.data.data;
          setAlluserTeams(statusdata);
          return statusdata
        })
        .catch((err) => {
          toast.error(err.response.data.error, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    };
  const filterCandidateData = async (
    string = "",
    page = 0,
    limit = 10,
    fieldName
  ) => {
    
    const url = `${config?.apiUrl}/api/get_all_search_candidate`;

    const queryObject = {
      page: page + 1,
      limit: limit,
      firstName: searchCandidateName,
      city: searchCandidateCity,
      candidate_ownerName: fieldName == "candidate_ownerName" ? string : searchCandidateOwnerName?.value || "",
      text: searchcandidate,
      designation: searchCandidateDesignation,
      candidate_id: uniqueCandidateId,
    };
    
      try {
        setSearchCandidateLoading(true);
        const filterdata = await axios.post(url, queryObject, {
          headers: {
            Authorization: `Bearer ${cookie.token}`,
            "Content-Type": "application/json",
          },
        })

        let temp = filterdata.data.data;
       const totalCandidates = filterdata.data.totalCandidates;
        temp.totalCandidates = totalCandidates;
        setCandidates(temp);
        setSearchCandidateLoading(false);
      } catch (error) {
        toast.error(error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSearchCandidateLoading(false);
      }
    
  };

  const SubmissionPreview = async (submissionid,value) => {
    try {
      const result = await axios.get(
        `${config?.apiUrl}/api/download_Submission_Resume/${submissionid}?id=${userId}`
      );
      setObjectURL(result.data);
      setLoading(false);
       const activityOn = `View resume of candidate ${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`;
        const activityDo = `View resume`;
        const component = "candidate";
        const reData = {
          name: `${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`,
          id: value?.candidateId?._id,
          action: "viewResume",
          type: "candidate",
          note: null,
        };
        userActivity(
          candidate_ownerName,
          userId,
          component,
          activityDo,
          activityOn,
          userRole,
          reData
        );
        // handleActivitySubmit &&
        //   handleActivitySubmit(
        //     value?._id,
        //     `View resume of ${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`,
        //     new Date().getTime(),
        //     candidate_ownerName,
        //     userId      
        //   );
        handleSubmissionPreviewShow(setSubmission(value), setId(value._id));
    } catch (error) {
      setObjectURL("no-resume");
      setLoading(false);
      toast.error("Error while Preview file. Try again later", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const [oldStatus, setOldStatus] = useState("");
  const fetchedBranchData = async () => {
    try {
      const url = `${config?.apiUrl}/api/get_all_client_branch/all_data`;
      const configHeader = {
        headers: {
          "Content-Type": "application/json",
          datavalue: "all_data",
        },
      };
      const response = await axios.get(url, configHeader);
      setClientBranch(response.data.data);
    } catch (error) {
       setClientBranch([]);
      console.error("Error fetching client branches:", error);
    }
  };

  useEffect(() => {
    fetchedBranchData()
    submissionid && setOldStatus(submission?.status);
  }, [submissionid]);

  const handleEditSubmissionStatus = async (e) => {
    if(e){
      e.preventDefault();
    }
    const { status } = submission;
    const url = `${config?.apiUrl}/api/appliedjob_update/${submissionid}`;
    const Credentials = { status, candidate_ownerName, userId };
    await axios
      .put(url, Credentials)
      .then(async (response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        const resonoseData = response.data.data;
        const changeStatus = {
          clientContactPerson: contact?.accountOwnerName,
          email: contact?.email,
          phone: contact?.phone,
        };
        const candidateId = await resonoseData?.candidateId;
        const updateData = {
          status: resonoseData?.status,
        };
        if (
          resonoseData?.status === "Joined" ||
          resonoseData?.status === "Submitted" ||
          resonoseData?.status === "Client - Submitted" ||
          resonoseData?.status === "Internal-Submitted"
        ) {
          updateData.candidateStatus =
            resonoseData?.status === "Client - Submitted"
              ? "QA Check"
              : resonoseData?.status === "Internal-Submitted"
                ? "Submitted"
                : resonoseData?.status;
        }

        const urls = `${config?.apiUrl}/api/update_candidate/${candidateId}`;
        await axios.put(urls, updateData).then((response) => {
          const mailSend = response.data.data?.sendMail;
          // if (mailSend) {
          //   handleUpdateStatusChangeMailSendToCandidate(
          //     submission,
          //     resonoseData,
          //     oldStatus,
          //     changeStatus
          //   );
          // }
        });

        setOldStatus("");
        handleEditSubmissionStatusClose();
        getAppliedJobdata(contactPage, rowsPerContactPage);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };
  const handleCandidateActivitySubmit = async (
    candidateId,
    _activityDes,
    _created_at,
    _submitterName,
    userId
  ) => {
    const response = await axios
      .post(`${config?.apiUrl}/api/Set_Candidateactivities`, {
        candidateId: candidateId,
        jobActivity: _activityDes,
        created_at: _created_at,
        submittedBy: _submitterName,
        submittedById: userId,
      })
      .then((result) => {
        console.log("success activity");
        // toast.success(result.data.msg, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleActivitySubmit = async (
    _jbid,
    _activityDes,
    _created_at,
    _clientId
  ) => {
    const response = await axios
      .post(`${config?.apiUrl}/api/Set_Jobactivities`, {
        jobId: _jbid,
        jobActivity: _activityDes,
        created_at: _created_at,
        clientId: _clientId,
      })
      .then((result) => {
        // toast.success(result.data.msg, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
            "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };
  const findDate = (changeDate) => {
    const selectedDate = new Date(changeDate ? changeDate : selectedJobdate);
    const day = String(selectedDate.getDate()).padStart(2, "0");
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    const year = selectedDate.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  };

  const handleFilterAllFieldStep = async (
    string = "",
    page = 0,
    rowsPerPage = 10,
    fieldName,
    isActive
  ) => {
    const baseUrl = `${config?.apiUrl}/api/get_all_search_jobpost?page=${page + 1}&limit=${rowsPerPage}&city=${fieldName == "city" ? string : searchcity}&state=${fieldName == "state" ? string : searchstate}&accountmanager=${fieldName === "accountmanager" ? string : searchaccountmanager || ""}&recruiter=${fieldName === "recruiter" ? string : searchrecruiter || ""}&teamleader=${fieldName === "teamleader" ? string : searchteamleader || ""}&status=${fieldName === "status" ? string : searchstatus}&clientContactName_Id=${id}&job_ownerName=${fieldName === "job_ownerName" ? string : searchJobOwner || ""}&startDate=${fieldName == "created_at" ? string?.startDate || "" : startDate}&endDate=${fieldName == "created_at" ? string?.endDate || "" : endDate} `;

    const url =`${baseUrl}`;

    const queryObject = {
      text: fieldName == "text" ? string : searchAllfields,
      jobtitle: fieldName == "jobtitle" ? string : searchjobtitle,
      skill: fieldName == "skill" ? string : searchskill,
      job_id: fieldName == "job_id" ? string : searchJobId,
      branch: fieldName == "branchTabJob" ? string : searchJobTabBranch || "",
      
    };

    try {
      setJobLoading(true);
      const filterdata = await axios.get(url, {
        params: queryObject,
        headers: {
          Authorization: `Bearer ${cookie.token}`,
          "Content-Type": "application/json",
        },
      });

      const clientJobsData = filterdata.data.data;
      const totalJobPosts = filterdata?.data?.totalJobPosts;
      clientJobsData.totalJobPosts = totalJobPosts;
      setTotalClientsPages(Math.ceil(totalJobPosts/rowsPerPage))
      setDisplayClientJobs(clientJobsData);
      
      setJobLoading(false);
      handlePopOverClose(false);
    } catch (error) {
      toast.error(error, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setJobLoading(false);
      handlePopOverClose(false);
    }
  };

  const job_ownerName = localStorage?.getItem("candidate_ownerName");

  const formik = useFormik({
    initialValues: {
      jobtitle: "",
      customer: "",
      country: "India",
      targetdate: "",
      recruiter: "",
      teamleader: "",
      status: "Active",
      customertype: "",
      jobtype: "Full Time",
      city: "",
      state: "",
      remotestatus: "Onsite",
       team: "",
      jobdescription: "",
      experience: "",
      clientId: "",
      clientContactName: "",
      accountName: "",
      email: "",
      numberofPosition: "",
      skill: "",
      question: "",
      placementType: "One Time Placement",
      clientpayType: "Annual Salary",
      ctc: "",
      onetimeplacementbillType: "",
      onetimeplacementbillValue: "",
      industry: "",
      ownerPhone: "",
      countryCode: "",
      stateCode: "",
         jobAddress: "",
            pincode:"",
    },
    validationSchema: addJobs(),
    onSubmit: async (data) => {
      setJobLoading(true);
      const jobData = {
        jobtitle: data.jobtitle,
        customer: data.customer,
        country: data.country,
        targetdate: data.targetdate,
        recruiter: data.recruiter,
        teamleader: data.teamleader,
        status: data.status,
        jobtype: data.jobtype,
        city: data.city,
        state: data.state,
        remotestatus: data.remotestatus,
         team:  data.team,
        jobdescription: data.jobdescription,
        experience: data.experience,

        clientId: contact?.accountId,
        clientContactName: contact?._id,
        numberofPosition: data.numberofPosition,
        skill: data.skill,
        question: data.question,
        placementType: data.placementType,
        clientpayType: data.clientpayType,
        ctc: data.ctc,

        onetimeplacementbillType: data.onetimeplacementbillType,
        onetimeplacementbillValue: data.onetimeplacementbillValue,
        job_ownerName: userId,
        job_updateOwnerName: userId,
        industry: data.industry || "",
        ownerPhone: data.ownerPhone,
        job_ownerName_Id: userId,
        job_updateOwnerName_Id: userId,
        countryCode: data?.countryCode || selectedState?.countryCode || "IN",
        stateCode: data?.stateCode || selectedState?.isoCode,
           jobAddress: data?.jobAddress || "",
            pincode:data?.pincode || "",
      };

      if (!data) {
        toast.error("Invalid credentials", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      const response = await axios
        .post(`${config?.apiUrl}/api/add_jobpost`, jobData)
        .then((result) => {
          toast.success(result.data.msg, {
            position: toast.POSITION.TOP_RIGHT,
          });
          const data = result?.data?.data;
          const activityOn = `Add new ${data?.jobtitle} job `;
          const activityDo = "Add Job";
          const component = "contact";
          const reData ={
            name:data?.jobtitle,
            id:result?.data?.data._id,
            action:'addJob',
            type:'job',
            note:null,
          }
          userActivity(
            candidate_ownerName,
            userId,
            component,
            activityDo,
            activityOn,
            userRole,
            reData
          );
          const jbid = result.data.data._id;

          const jbtitle = result.data.data?.jobtitle;

          const clientid = result?.data?.data?.clientId;
          handleActivitySubmit(
            jbid,
            `Job " ${jbtitle} "has been created by ${candidate_ownerName}`,
            new Date().getTime(),
            clientid
          );
          setJobpost({
            jobtitle: "",
            customer: "",
            country: "",
            targetdate: "",
            recruiter: "",
            teamleader: "",
            status: "",
            customertype: "",
            jobtype: "",
            city: "",
            state: "",
            remotestatus: "",
            accountmanager: "",
            jobdescription: "",
            experience: "",
            clientId: "",
            clientContactName: "",
            accountName: "",
            email: "",
            numberofPosition: "",
            skill: "",
            question: "",
            placementType: "",
            clientpayType: "",
            ctc: "",
            onetimeplacementbillType: "",
            onetimeplacementbillValue: "",
          });
          setSelectedCountry({
            name: "India",
            isoCode: "IN",
          });
          setSelectedState("");
          setSelectedCity("");
          handlePostClose();
          handleFilterAllFieldStep(
            "",
            page,
            rowsPerPage,
           
          );
          setJobLoading(false);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.msg || "Please check details", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setJobLoading(false);
        });
    },
  });

  const [updateOwnerName, setUpdateOwnerName] = useState("");

  const getJobs = (val) => {
    editFormik.setValues({
      jobtitle: val.jobtitle,
      customer: val.customer,
      country: val.country,
      targetdate: val.targetdate,
      recruiter: val.recruiter,
      teamleader: val.teamleader,
      status: val.status,
      jobtype: val.jobtype,
      city: val.city,
      state: val.state,
      remotestatus: val.remotestatus,
      accountmanager: val.accountmanager,
      jobdescription: val.jobdescription,
      experience: val.experience,
      clientId: val.clientId._id,
      clientContactName: val.clientContactName,
      numberofPosition: val.numberofPosition,
      skill: val.skill,
      question: val.question,
      placementType: val.placementType,
      clientpayType: val.clientpayType,
      ctc: val.ctc,
      onetimeplacementbillType: val.onetimeplacementbillType,
      onetimeplacementbillValue: val.onetimeplacementbillValue,
      jobAddress: val?.jobAddress || "",
      pincode: val?.pincode || "",
      job_ownerName: userId,
      industry: val.industry || "",
      branch: val?.branch?._id || val.branch ||"",
      ownerPhone: val?.ownerPhone
        ? val?.ownerPhone
        : val?.jobOwnerDetails?.phone,
    });
   
   
   setUpdateOwnerName(
      val?.job_updateOwnerName_Id
        ? getOptionById(val.job_updateOwnerName_Id, userNames)?.label
        : getOptionById(val?.job_ownerName_Id, userNames)?.label
    );
  const team = alluserTeams.filter((team) => team._id === val.team);
  setSelectedTeamD(team[0]);
  // const contacts =  getContactdata(0,tableRowsPerPage['contact'],val.clientId._id);
  setUpdateOwnerName(
    `${val?.job_owener_data?.firstName} ${val?.job_owener_data?.lastName}`
  );
  setSelectedTeamLeader(getOptionById(val.teamleader_Id, reduxUserNames));
  setSelectedRecruiter(getOptionById(val.recruiter_Id, reduxUserNames));
  setSelectedAccountManager({ value: team[0]?._id, label: team[0]?.teamName });
  const memberIds = team[0]?.membersByLead[val.teamleader_Id];
  const recruiters = team[0]?.members?.filter((recruiter) =>
    memberIds?.includes(recruiter?._id)
  );
  if (recruiters?.length === 0) {
    setRecruiters(selectedTeamD?.members);
  } else {
    // setSelectedRecruiter(null);
    setRecruiters(recruiters);
  }
  setSelectedState({
    name: val?.state,
    countryCode: val?.countryCode,
    isoCode: val?.stateCode,
  });
    setSelectedCity({
      name: val?.city,
      countryCode: val?.countryCode,
      isoCode: val?.stateCode,
    });
    
  };

  // Job Edit Form functionality

  const editFormik = useFormik({
    initialValues: {
      jobtitle: "",
      customer: "",
      country: "India",
      targetdate: "",
      recruiter: "",
      teamleader: "",
      status: "",
      jobtype: "",
      city: "",
      state: "",
      remotestatus: "",
      team: "",
      jobdescription: "",
      experience: "",
      clients: "",
      clientId: "",
      clientContactName: "",
      accountName: "",
      email: "",
      numberofPosition: "",
      skill: "",
      question: "",
      placementType: "",
      clientpayType: "",
      ctc: "",
      onetimeplacementbillType: "",
      onetimeplacementbillValue: "",
      industry: "",
      ownerPhone: "",
      jobAddress:"",
      pincode:""
    },
    validationSchema: addJobs(),
    onSubmit: async (data) => {
      setJobLoading(true);
      const url = `${config?.apiUrl}/api/update_jobpost/${jobid}`;
      const Credentials = {
        jobtitle: data.jobtitle,
        customer: data.customer,
        country: data.country,
        targetdate: data.targetdate,
        recruiter: data.recruiter,
        teamleader: data.teamleader,
        status: data.status,
        jobtype: data.jobtype,
        city: data.city,
        state: data.state,
        remotestatus: data.remotestatus,
        team: data.team,
        jobdescription: data.jobdescription,
        experience: data.experience,

        clientId: data.clientId,
        clientContactName: data.clientContactName,

        numberofPosition: data.numberofPosition,
        skill: data.skill,
        question: data.question,
        placementType: data.placementType,
        clientpayType: data.clientpayType,
        ctc: data.ctc,
        onetimeplacementbillType: data.onetimeplacementbillType,
        onetimeplacementbillValue: data.onetimeplacementbillValue,
        // job_ownerName: job_ownerName,
        job_updateOwnerName: userId,
        industry: data.industry || "",
        ownerPhone: data.ownerPhone,
        countryCode: data?.countryCode || selectedState?.countryCode || "IN",
        stateCode: data?.stateCode || selectedState?.isoCode,
        jobAddress:data?.jobAddress,
        pincode: data?.pincode,
      };

      await axios
        .put(url, Credentials)
        .then((response) => {
          toast.success(response.data.msg, {
            position: toast.POSITION.TOP_RIGHT,
          });
          const data = response?.data?.data;
          const activityOn = `Update  ${data?.jobtitle} job `;
          const activityDo = "Update Job";
          const component = "contact";
          const reData ={
            name:data?.jobtitle,
            id:jobid,
            action:'editJob',
            type:'job',
            note:null,
          }
          data?.jobtitle
          userActivity(
            candidate_ownerName,
            userId,
            component,
            activityDo,
            activityOn,
            userRole,
            reData
          );
          const jbid = response.data.data._id;

          handleActivitySubmit(
            jbid,
            `Job ${data?.jobtitle} has been edited by "${candidate_ownerName}"`,
            new Date().getTime(),
            data.clientId
          );
          handleEditClose();
          // getContactJobsdata(
          //   page,
          //   rowsPerPage,
          //   contact.accountName,
          //   contact?.accountOwnerName
          // );
          handleFilterAllFieldStep("", 0, 10);
          setJobLoading(false);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.msg || "Please check details", {
            position: toast.POSITION.TOP_RIGHT,
          });
          console.log("err::::::::::::", err);
          setJobLoading(false);
        });
    },
  });
  const job_updateOwnerName = localStorage?.getItem("candidate_ownerName");

  const handleDelete = async (e) => {
    e.preventDefault();
    const url = `${config?.apiUrl}/api/remove_jobpost/${jobid}`;
    await axios
      .delete(url)
      .then((response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        const data = response?.data?.data;
        const activityOn = `${data?.jobs?.jobtitle} job has been deleted `;
        const activityDo = "Delete Job";
        const component = "jobpost";
        const reData = {
          action: "deleteJob",
          type: "job",
          note: null,
        };
        userActivity(
          candidate_ownerName,
          userId,
          component,
          activityDo,
          activityOn,
          userRole,
          reData
        );
        handleDeleteJobClose();
        handleFilterAllFieldStep(
          activeField.value,
          page,
          rowsPerPage,
          activeField.name
        );
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleDeleteSubmission = async (e) => {
    e.preventDefault();
    const url = `${config?.apiUrl}/api/remove_submission/${submissionid}`;
    await axios
      .delete(url)
      .then((response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });

        const submissionData = response?.data?.data;
        const activityOn = `Delete submission ${submissionData?.candidateId} `;
        const activityDo = "Delete submission";
        const component = "account";
        const reData = {
          action: "deleteSubmission",
          type: "submission",
          note: null,
        };
        userActivity(
          candidate_ownerName,
          userId,
          component,
          activityDo,
          activityOn,
          userRole,
          reData
        );
        handleDeleteSubmissionClose();
        // getAppliedJobdata(contactPage, rowsPerContactPage);
        handleFilterAllFieldStep("", 0, 10);
        setSubmissionId("");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (
      searchAllfields.length !== 0 ||
      (activeField.name !== "" && activeField.value !== "")
    ) {
      handleFilterAllFieldStep(
        activeField.value,
        newPage,
        rowsPerPage,
        activeField.name
      );
    } else {
      handleFilterAllFieldStep(
        activeField.value,
        newPage,
        rowsPerPage,
        activeField.name
      );
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    if (
      searchAllfields.length !== 0 ||
      (activeField.name !== "" && activeField.value !== "")
    ) {
      handleFilterAllFieldStep(
        activeField.value,
        0,
        +event.target.value,
        activeField.name
      );
    } else {
      handleFilterAllFieldStep(
        activeField.value,
        0,
        +event.target.value,
        activeField.name
      );
    }
  };
  const getContact = async (id) => {
    try {
      const response = await axios.get(`${config?.apiUrl}/contactview/${id}`);

      const contactdata = response.data.data;
      setContact(contactdata);
      setDisplayContact(contactdata);
      setAccountContactId(contactdata?.accountId);
      setAccountContactName(contactdata?.accountOwnerName);
      contactdata.accountName &&
        contactdata?.accountOwnerName &&
        (await handleFilterAllFieldStep(
          "",
          page,
          rowsPerPage,
        
        ));
    } catch (err) {
      toast.error(err?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const handleResumeMatching = async (e) => {
    setLoadingResumeScreening(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", submission?.file);
    formData.append("fileName", submission?.fileName);
    formData.append("filePath", submission?.filePath);
    formData.append("jobRequirement", JSON.stringify(jobpost));
    formData.append("requiredSkill", submission?.skill);

    await axios
      .post(`${config?.apiUrl}/api/resume_screening`, formData)
      .then((result) => {
        toast.success(result.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoading(false);
        const pasreConclusion = result.data.data?.conclusion;
        setLoadingResumeScreening(false);
        const requiredSkill = submission?.skill || submission?.candidateId?.skill;
        const rdata = JSON.parse(result.data.data?.jsonResponse);
        const pAge = rdata?.age;
        setParseAge(pAge);
        const percentMatch = result.data.data?.percentageMatch;
        setParsePercentage(percentMatch);
        let parsedSkills = Array.isArray(rdata.skills)
          ? rdata.skills
          : rdata.skills.split(",");

        const requiredSkillsArray = requiredSkill?.split(",");

        const matchedSkills = parsedSkills?.filter((parsedSkill) => {
          return requiredSkillsArray.some((reqSkill) => {
            // Check if the beginning of any word in parsedSkill matches the beginning of reqSkill
            const parsedWords = parsedSkill.toLowerCase().split(" ");
            const reqWords = reqSkill.toLowerCase().split(" ");

            return parsedWords.some((parsedWord) =>
              reqWords.some(
                (reqWord) =>
                  parsedWord.startsWith(reqWord) ||
                  reqWord.startsWith(parsedWord)
              )
            );
          });
        });

        const missingSkills = requiredSkillsArray?.filter(
          (reqSkill) =>
            !matchedSkills.some(
              (matchedSkill) =>
                matchedSkill.toLowerCase().startsWith(reqSkill.toLowerCase()) ||
                reqSkill.toLowerCase().startsWith(matchedSkill.toLowerCase())
            )
        );

        setMatchingSkills(matchedSkills);
        setMissingSkills(missingSkills);
        setParsedSkills(parsedSkills);
        setparseResumeConclusion(pasreConclusion);
        setLoading(false);
        setLoadingResumeScreening(false);
        document.getElementsByClassName("matched_skill")[0].style.display =
          "block";
        document.getElementsByClassName("conclusion")[0].style.display =
          "block";
        if (matchedSkills.length === 0) {
          toast.error("You don't match the required skills.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status == 404) {
          // Display toaster for file not found in the database
          toast.error("Resume file not found in the database.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoadingResumeScreening(false);
        } else {
          // Display a general error toaster
          toast.error(
            "Please check your resume or try again later. If the issue persists, please add your resume.",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
          setLoadingResumeScreening(false);
        }
        setLoading(false);
        setLoadingResumeScreening(false);
      });
  };

  const filterJobData = async (filterValue, filterField) => {
    switch (filterField) {
      case "clientName":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "clientName"
        );
        setIsFilterActiveJclient(filterValue?.length !== 0 ? true : false);
        break;

      case "jobTitle":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "jobtitle"
        );
        setIsFilterActiveJobt(filterValue?.length !== 0 ? true : false);
        break;
        case "branchTabJob":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "branchTabJob"
        );
        setIsFilterActiveTabJobBranch(filterValue?.length !== 0 ? true : false);
        break;

      case "city":
        await handleFilterAllFieldStep(filterValue, page, rowsPerPage, "city");
        setIsFilterActiveCity(filterValue?.length !== 0 ? true : false);
        break;

      case "state":
        await handleFilterAllFieldStep(filterValue, page, rowsPerPage, "state");
        setIsFilterActiveState(filterValue?.length !== 0 ? true : false);
        break;

      case "contactperson":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "clientContactName"
        );
        setIsFilterActiveContactPerson(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "accountmanager":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "accountmanager"
        );
        setIsFilterActiveActMang(filterValue?.length !== 0 ? true : false);
        break;

      case "recruiter":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "recruiter"
        );
        setIsFilterActiveRecruiter(filterValue?.length !== 0 ? true : false);
        break;

      case "teamleader":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "teamleader"
        );
        setIsFilterActiveTlead(filterValue?.length !== 0 ? true : false);
        break;
      case "owner_name":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "/api/get_all_search_jobpost"
        );
        setIsFilterJobActiveOwner(filterValue?.length !== 0 ? true : false);
        break;

      case "skill":
        await handleFilterAllFieldStep(filterValue, page, rowsPerPage, "skill");
        setIsFilterActiveSkill(filterValue?.length !== 0 ? true : false);
        break;

      case "status":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "status"
        );
        setIsFilterActiveStatus(filterValue?.length !== 0 ? true : false);
        break;
        case "job_id":
          await handleFilterAllFieldStep(
            filterValue,
            page,
            rowsPerPage,
            "job_id"
          );
          setIsFilterActiveJobId(filterValue?.length !== 0 ? true : false);
          break;

      case "date":
        await handleFilterAllFieldStep(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "created_at"
        );
        setIsFilterActiveJdate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;

      default:
        break;
    }
  };

  const handleEditStatus = async (e) => {
    e.preventDefault();
    const { status } = jobpost;
    const url = `${config?.apiUrl}/api/update_jobpost/${jobid}`;
    const Credentials = { status, job_updateOwnerName };
    await axios
      .put(url, Credentials)
      .then((response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        handleEditStatusClose();
        // getContactJobsdata(
        //   page,
        //   rowsPerPage,
        //   contact.accountName,
        //   contact?.accountOwnerName
        // );
        handleFilterAllFieldStep(
          activeField.value,
          page,
          rowsPerPage,
          activeField.name
        );
        const activityOn = `Status has been change to ${response.data?.data?.status} for jobtitle ${response.data?.data?.jobtitle} `;
        const activityDo = "Update status";
        const component = "account";
        const reData ={
          name:response.data?.data?.jobtitle,
          id:jobid,
          action:'editJob',
          type:'job',
          note:null,
        }
        userActivity(
          candidate_ownerName,
          userId,
          component,
          activityDo,
          activityOn,
          userRole,
          reData,
        );
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleAppliedJobClientEmailSend = async (formData) => {
    const { clientemail, email, clientId, jobId } = formData;
    const jobDetails = displayClientJobs.find((job) => job._id === jobId);
    const jobTitle = jobDetails?.jobtitle;

    if (!formData) {
      toast.error("Invalid credentials", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const response = await axios
      .post(`${config?.apiUrl}/api/Job_Applied_Client_EmailSend`, {
        email: clientemail,
        candidateEmail: email,
        clientId: clientId,
        jobTitle: jobTitle,
      })
      .then((result) => {
        toast.success(result?.data?.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
            "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const handleAppliedJobEmailSend = async (formData) => {
    const { email, jobId } = formData;

    const jobDetails = displayClientJobs.find((job) => job._id === jobId);

    if (!formData) {
      toast.error("Invalid credentials", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const response = await axios
      .post(`${config?.apiUrl}/api/Job_Applied_EmailSend`, {
        email: email,
        jobDetails: jobDetails,
      })
      .then((result) => {
        toast.success(result?.data?.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
            "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const clearCandidateSearchFilter = () => {
    setSearchcandidate("");
    setSearchCandidateName("");
    setCandidateSearchActiveField({ name: "", value: "" });
    setSearchCandidateDesignation("");
    setSearchCandidateCity("");
    setSearchCandidateOwnerName(null);
    filterCandidateData("",candidatesubmissionpage, rowsPerCandidateSubmissionPage);
  };

  const clearJobFilter = () => {
    setActiveField({ name: "", value: "" });
    setSearchAllfields("");
    setSearchJobId("");
    setIsFilterActiveJobId(false)
    setSearchJob("");
    setSearchJobtitle("");
    setSearchAccountmanager([]);
    setSearchStatus("");
    setSearchRecruiter([]);
    setSearchJobOwner([]);
    setSearchTeamleader([]);
    setSearchCity([]);
    setSearchState([]);
    setSearchSkill("");
    setSelectedJobDate("");
    setStartDate("");
    setEndDate("");
    setIsFilterActiveJclient(false);
    setIsFilterActiveJobt(false);
    setIsFilterActiveCity(false);
    setIsFilterActiveState(false);
    setIsFilterActiveActMang(false);
    setIsFilterActiveContactPerson(false);
    setIsFilterActiveRecruiter(false);
    setIsFilterActiveSkill(false);
    setIsFilterActiveStatus(false);
    setIsFilterActiveJdate(false);
    setIsFilterJobActiveOwner(false);
    setIsFilterActiveTlead(false);
    handleFilterAllFieldStep(
      "",
      page,
      rowsPerPage,
    );
  };

  // This function is for getting client contact submission by its id
  const [teamData, setTeamData] = useState([]);
  const [submissionModuleData, setSubmissionModuleData] = useState({});

  // const getAppliedJobdata = async (
  //   getpage = 0,
  //   rowperpage = 10,
  //   response = {}
  // ) => {
  //   setLoading(true);

  //   await axios
  //     .get(
  //       // `${config?.apiUrl}/api/get_accountContactPerson_Submissions?id=${id}&page=${getpage + 1}&limit=${rowperpage}&submissionOwnerName=${(response?.view == "ownrecords" || response?.view == "ownandteamrecords") && cookie?.role !== "Admin" ? userId : ""}&permissionValue=${response?.view == "ownandteamrecords" ? "ownandteamrecords" : ""}&clientId=${contact.accountId}`
  //        `${config?.apiUrl}/api/get_accountContactPerson_Submissions?id=${id}&page=${getpage + 1}&limit=${rowperpage}&clientId=${contact.accountId}`
  //     )
  //     .then((response) => {
  //       if (response.data.status !== "error") {
  //         const appliedJobData = response.data.data;
  //         const totalSubmissionCount = response.data.totalSubmissionCount;
  //         appliedJobData.totalSubmissionCount = totalSubmissionCount;
  //         setTotalPages(Math.ceil(totalSubmissionCount / rowsPerPage))
  //         setAppliedJob(appliedJobData);
  //         setDisplayAppliedJob(appliedJobData);
  //         const teams = response?.data?.team;
  //         setTeamData(teams);
  //         setLoading(false);

  //         const pipelnefiltered = appliedJobData.filter((val) => {
  //           return val.status === "Client - Submitted";
  //         });
  //         setPipelinedCandidates(pipelnefiltered);

  //         const Interviewfiltered = appliedJobData.filter((val) => {
  //           return val.status === "Interview Scheduled";
  //         });
  //         setInterviewedCandidates(Interviewfiltered);

  //         const Selectedfiltered = appliedJobData.filter((val) => {
  //           return val.status === "Selected";
  //         });
  //         setSelectedCandidates(Selectedfiltered);

  //         const Acceptedfiltered = appliedJobData.filter((val) => {
  //           return val.status === "Joined";
  //         });
  //         setJoinedCandidates(Acceptedfiltered);

  //         const Onboardedfiltered = appliedJobData.filter((val) => {
  //           return val.status === "Onboarded";
  //         });
  //         setOnboardedCandidates(Onboardedfiltered);
  //       } else {
  //         setAppliedJob([]);
  //         setDisplayAppliedJob([]);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((err) => {
  //       toast.error(err?.response?.data?.error, {
  //         position: toast.POSITION.TOP_RIGHT,
  //       });
  //       setLoading(false);
  //     });
  // };
  const [moduleData, setModuleData] = useState({});
  const [searchfname, setSearchFname] = useState("");
  const [searchlname, setSearchLname] = useState("");
  const [searchjobt, setSearchJobt] = useState("");
  const [searchstatus, setSearchStatus] = useState([]);
  const [searchcustomer, setSearchCustomer] = useState([]);
  const [searchOwnerName, setSearchOwnerName] = useState([]);
  const [searchcandidatectctype, setSearchCandidatectctype] = useState("");
  const [searchcandidatectc, setSearchCandidatectc] = useState("");
  const [searchState, setSearchstate] = useState([]);
  const [searchExpectedCandidateCTC, setSearchExpectedCandidateCTC] =
    useState("");
  const [searchExpectedCandidateCTCType, setSearchExpectedCandidateCTCType] =
    useState("");
  const [searchNoticePeriod, setSearchNoticePeriod] = useState("");
  const [searchPhone, setSearchphone] = useState("");
  const [searchAddress, setSearchAddress] = useState("");
  const [searchDOB, setSearchDOB] = useState("");
  const [searchAadharCardNumber, setSearchAadharCardNumber] = useState("");
  const [searchPanCardNumber, setSearchPanCardNumber] = useState("");
  const [searchDesignation, setSearchdesignation] = useState("");
  const [searchWorkExperience, setSearchWorkExperience] = useState("");
  const [searchEducationDetails, setSearchEducationDetails] = useState("");
  const [searchExperience, setSearchExperience] = useState(null);
  const [searchGender, setSearchGender] = useState("");
  const [searchInterviewScheduleDate, setSearchInterviewScheduleDate] =
    useState([]);
  const [searchInterviewScheduleTime, setSearchInterviewScheduleTime] =
    useState("");
  const [searchInterviewScheduleLocation, setSearchInterviewScheduleLocation] =
    useState("");
  const [searchInterviewScheduleLink, setSearchInterviewScheduleLink] =
    useState("");
  const [searchstatusSubmission, setSearchStatusSubmission] = useState([]);
  const [searchJoinDate, setSearchJoinDate] = useState([]);
  const [searchSubmissionBy, setSearchSubmissionBy] = useState([]);
  const [searchEmail, setSearchemail] = useState("");
  const [searchContactName, setSearchContactName] = useState("");
  const [searchActualCTC, setSearchActualCTC] = useState("");
  const [searchOfferCTC, setSearchOfferCTC] = useState("");
  const [searchExpectedJoinDate, setSearchExpectedJoinDate] = useState([]);
  const [searchUpdatedBy, setSearchUpdatedBy] = useState([]);
  const [searchFullName, setSearchFullName] = useState("");
  const [searchIndustry, setSearchIndustry] = useState([]);
  const [searchcitySubmission, setSearchCitySubmission] = useState([]);
  const [searchInterviewRescheduleDate, setSearchInterviewRescheduleDate] =
    useState([]);
  const [searchTestRescheduleDate, setSearchTestRescheduleDate] = useState([]);
  const [searchBackoutDate, setSearchBackoutDate] = useState([]);

  const [isFilterActiveBackoutDate, setIsFilterActiveBackoutDate] =
    useState(false);
  const [
    isFilterActiveTestRescheduleDate,
    setIsFilterActiveTestRescheduleDate,
  ] = useState(false);
  const [
    isFilterActiveInterviewRescheduleDate,
    setIsFilterActiveInterviewRescheduleDate,
  ] = useState(false);
  const [isFilterActiveStateSubmission, setIsFilterActiveStateSubmission] =
    useState(false);
  const [isFilterActiveCitySubmission, setIsFilterActiveCitySubmission] =
    useState(false);
  const [isFilterActiveStatusSubmission, setIsFilterActiveStatusSubmission] =
    useState(false);
  const [isFilterActiveIndustry, setIsFilterActiveIndustry] = useState(false);
  const [isFilterActiveFullName, setIsFilterActiveFullName] = useState(false);
  const [isFilterActiveUpdatedBy, setIsFilterActiveUpdatedBy] = useState(false);
  const [isFilterActiveExpectedJoinDate, setIsFilterActiveExpectedJoinDate] =
    useState(false);
  const [isFilterActiveUpdatedDate, setIsFilterActiveUpdatedDate] =
    useState(false);
  const [isFilterActiveOfferCTC, setIsFilterActiveOfferCTC] = useState(false);
  const [isFilterActiveActualCTC, setIsFilterActiveActualCTC] = useState(false);
  const [isFilterActiveEmail, setIsFilterActiveEmail] = useState(false);
  const [isFilterActiveSubmissionBy, setIsFilterActiveSubmissionBy] =
    useState(false);
  const [isFilterActiveJoinDate, setIsFilterActiveJoinDate] = useState(false);
  const [
    isFilterActiveInterviewScheduleLink,
    setIsFilterActiveInterviewScheduleLink,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleLocation,
    setIsFilterActiveInterviewScheduleLocation,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleTime,
    setIsFilterActiveInterviewScheduleTime,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleDate,
    setIsFilterActiveInterviewScheduleDate,
  ] = useState(false);
  const [isFilterActiveGender, setIsFilterActiveGender] = useState(false);
  const [isFilterActiveExperience, setIsFilterActiveExperience] =
    useState(false);
  const [isFilterActiveEducationDetails, setIsFilterActiveEducationDetails] =
    useState(false);
  const [isFilterActiveWorkExperience, setIsFilterActiveWorkExperience] =
    useState(false);
  const [isFilterActiveDesignation, setIsFilterActiveDesignation] =
    useState(false);
  const [isFilterActivePanCardNumber, setIsFilterActivePanCardNumber] =
    useState(false);
  const [isFilterActiveAadharCardNumber, setIsFilterActiveAadharCardNumber] =
    useState(false);
  const [isFilterActiveDOB, setIsFilterActiveDOB] = useState(false);
  const [isFilterActiveAddress, setIsFilterActiveAddress] = useState(false);
  const [isFilterActivePhone, setIsFilterActivePhone] = useState(false);
  const [isFilterActiveNoticePeriod, setIsFilterActiveNoticePeriod] =
    useState(false);
  const [isFilterActivEexpectedCtctype, setIsFilterActiveExpectedCtctype] =
    useState(false);
  const [isFilterActiveExpectedCtc, setIsFilterActiveExpectedCtc] =
    useState(false);
  const [isFilterActiveFname, setIsFilterActiveFname] = useState(false);
  const [isFilterActiveLname, setIsFilterActiveLname] = useState(false);
  const [isFilterActiveClient, setIsFilterActiveClient] = useState(false);
  const [isFilterActiveOwner, setIsFilterActiveOwner] = useState(false);
  const [isFilterActiveCtctype, setIsFilterActiveCtctype] = useState(false);
  const [isFilterActiveCtc, setIsFilterActiveCtc] = useState(false);
  const [isFilterActiveContactName, setIsFilterActiveContactName] =
    useState(false);

  const statusField = "all";
  const [mySubmissionValue, setMySubmissionValue] = useState("");

  const handleFilterAllFieldSteps = async (
    string = "",
    page = 0,
    rowsPerPage = 10,
    fieldName
  ) => {
    const isClientView = true;
    const clientId = contact?.accountId;

    const contactId = contact?._id;

    const url = `${config?.apiUrl}/api/get_All_search_submission?page=${page + 1}&limit=${rowsPerPage}&candidateFirstName=${fieldName == "candidateFirstName" ? string : searchfname}&candidateLastName=${fieldName == "candidateLastName" ? string : searchlname}&email=${fieldName == "email" ? string : searchEmail}&status=${fieldName == "status" ? string : searchstatusSubmission}&ownerName=${
      fieldName == "ownerName" ? string : searchOwnerName || ""
    }&currentCandidateCTC=${fieldName == "currentCandidateCTC" ? string : searchcandidatectc}&expectedCandidateCTC=${fieldName == "expectedCandidateCTC" ? string : searchExpectedCandidateCTC}&currentCandidateCTCType=${fieldName == "currentCandidateCTCType" ? string : searchcandidatectctype}&expectedCandidateCTCType=${fieldName == "expectedCandidateCTCType" ? string : searchExpectedCandidateCTCType}&city=${fieldName == "city" ? string : searchcitySubmission || ""}&state=${fieldName == "state" ? string : searchState || ""}&contactNameId=${contactId !== undefined ? contactId : fieldName == "contactName" ? string :""}&noticePeriod=${fieldName == "noticePeriod" ? string : searchNoticePeriod && `${searchNoticePeriod?.noticePeriod[0] || 0}-${searchNoticePeriod?.noticePeriod[1]}`}&address=${fieldName == "address" ? string : searchAddress}&DOB=${fieldName == "DOB" ? string : searchDOB}&pancardNumber=${fieldName == "pancardNumber" ? string : searchPanCardNumber}&aadharcardNumber=${fieldName == "aadharcardNumber" ? string : searchAadharCardNumber}&gender=${fieldName == "gender" ? string : searchGender}&workExperience=${fieldName == "workExperience" ? string : searchWorkExperience}&educationDetails=${fieldName == "educationDetails" ? string : searchEducationDetails}&submissionBy=${
      fieldName == "submissionBy"
          ? string || ""
          : searchSubmissionBy || ""
      // cookie?.role != "Admin"
      //   ? moduleData?.view == "ownrecords"
      //     ? candidate_ownerName?.trim()
      //     : moduleData?.view == "ownandteamrecords"
      //       ? fieldName == "submissionBy"
      //         ? teamData && teamData?.includes(string)
      //           ? string || ""
      //           : null
      //         : searchSubmissionBy?.length !== 0
      //           ? searchSubmissionBy
      //           : teamData
      //             ? teamData
      //             : null
      //       : fieldName == "submissionBy"
      //         ? string || ""
      //         : searchSubmissionBy || ""
      //   : fieldName == "submissionBy"
      //     ? string || ""
      //     : searchSubmissionBy || ""
    }&statusField=${statusField !== undefined ? statusField : ""}&candidateSource=${fieldName == "candidateSource" ? string : searchSourceData}&interviewScheduleDate=${fieldName == "interviewScheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchInterviewScheduleDate || ""}&interviewScheduleTime=${fieldName == "interviewScheduleTime" ? string : searchInterviewScheduleTime}&interviewScheduleLocation=${fieldName == "interviewScheduleLocation" ? string : searchInterviewScheduleLocation}&interviewScheduleLink=${fieldName == "interviewScheduleLink" ? string : searchInterviewScheduleLink}&joinDate=${fieldName == "joinDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchJoinDate || ""}&actualCTC=${fieldName == "actualCTC" ? string : searchActualCTC}&expectedJoinDate=${fieldName == "expectedJoinDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchExpectedJoinDate || ""}&offerCTC=${fieldName == "offerCTC" ? string : searchOfferCTC}&isClientView=${isClientView !== undefined ? isClientView : ""}&updatedBy=${fieldName == "updatedBy" ? string : searchUpdatedBy || ""}&candidateFullName=${fieldName == "candidateFullName" ? string : searchFullName}&industry=${fieldName == "industry" ? string : searchIndustry || ""}&createdAt=${fieldName == "created_at" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchSubmissionDate || ""}&updatedAt=${fieldName == "updated_at" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchSubmissionUpdateDate || ""}&interviewRescheduleDate=${fieldName == "interviewRescheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchInterviewRescheduleDate || ""}&testRescheduleDate=${fieldName == "testRescheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchTestRescheduleDate || ""}&backoutDate=${fieldName == "backoutDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchBackoutDate || ""}`;

    const queryObject = {
      searchText: fieldName == "text" ? string : searchAllfields,
      jobtitle: fieldName == "jobtitle" ? string : searchjobt,
      designation: fieldName == "designation" ? string : searchDesignation,
      phone: fieldName == "phone" ? string : searchPhone,
      submissionId: fieldName =='submission_id' ? string:searchSubmissionId,
      branch: fieldName == "branch" ? string : searchBranch,
      experienceMin:
      fieldName == "experience"
        ? string?.experience && string?.experience[0] !== undefined &&
          string?.experience[0] !== null &&
          (!isNaN(string?.experience[0]) || string?.experience[0] === 0)
          ? string?.experience[0]
          : null
        : searchExperience?.experience[0] !== undefined &&
            searchExperience?.experience[0] !== null &&
            (!isNaN(searchExperience?.experience[0]) || searchExperience?.experience[0] === 0)
          ? searchExperience?.experience[0]
          : null,
    experienceMax:
      fieldName == "experience"
        ? string?.experience && string?.experience[1] !== undefined &&
          string?.experience[1] !== null &&
          (!isNaN(string?.experience[1]) || string?.experience[1] === 0)
          ? string?.experience[1]
          : null
        : searchExperience?.experience[1] !== undefined &&
            searchExperience?.experience[1] !== null &&
            (!isNaN(searchExperience?.experience[1]) || searchExperience?.experience[1] === 0)
          ? searchExperience?.experience[1]
          : null,
    };

    try {
      setLoading !== undefined && setLoading(true);
      const filterdata = await axios.get(url, {
        params: queryObject,
        headers: {
          Authorization: `Bearer ${cookie?.token}`,
          "Content-Type": "application/json",
        },
      });

      const allSubmissionData = filterdata.data.data;

      const totalSubmissionCount = filterdata.data.totalSubmissionCount;
      allSubmissionData.totalSubmissionCount = totalSubmissionCount;
      setAppliedJob(allSubmissionData);
      handlePopOverCloseSubmission(false);
      // setDisplaySubmissions(allSubmissionData);
      setDisplayAppliedJob(allSubmissionData);
      setLoading !== undefined && setLoading(false);
      return allSubmissionData;
    } catch (error) {
      toast.error(error?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      handlePopOverCloseSubmission(false);
      setLoading !== undefined && setLoading(false);
    }
  };
  const filterData = async (filterValue, filterField, filterDate) => {
    switch (filterField) {
      case "industry":
        await handleFilterAllFieldSteps(
          filterValue,
          page,
          rowsPerPage,
          "industry"
        );
        setIsFilterActiveIndustry(filterValue?.length !== 0 ? true : false);
        break;
         case "branch":
              await handleFilterAllFieldSteps(
                filterValue,
                page,
                rowsPerPage,
                "branch",
              );
              setIsFilterActiveBranch(filterValue?.length == 0 ? false : true);
              break;
      case "firstName":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "candidateFirstName"
        );
        setIsFilterActiveFname(filterValue?.length == 0 ? false : true);
        break;
      case "fullName":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "candidateFullName"
        );
        setIsFilterActiveFullName(filterValue?.length == 0 ? false : true);
        break;

      case "lastName":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "candidateLastName"
        );
        setIsFilterActiveLname(filterValue?.length == 0 ? false : true);
        break;

      case "email":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "email"
        );
        setIsFilterActiveEmail(filterValue?.length == 0 ? false : true);

        break;

      case "jobTitle":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "jobtitle"
        );
        setIsFilterActiveJobt(filterValue?.length == 0 ? false : true);
        break;

      case "status":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "status"
        );
        setIsFilterActiveStatusSubmission(
          filterValue?.length == 0 ? false : true
        );
        break;

      case "client":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "clientName"
        );
        setIsFilterActiveClient(filterValue?.length == 0 ? false : true);
        break;

      case "contactName":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "contactName"
        );
        setIsFilterActiveContactName(filterValue?.length == 0 ? false : true);
        break;

      case "owner_name":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "ownerName"
        );
        setIsFilterActiveOwner(filterValue?.length == 0 ? false : true);

        break;

      case "currentCandidateCTCType":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "currentCandidateCTCType"
        );
        setIsFilterActiveCtctype(filterValue?.length !== 0 ? true : false);
        break;

      case "currentCandidateCTC":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "currentCandidateCTC"
        );
        setIsFilterActiveCtc(filterValue?.length !== 0 ? true : false);
        break;

      case "expectedCandidateCTCType":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "expectedCandidateCTCType"
        );
        setIsFilterActiveExpectedCtctype(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "expectedCandidateCTC":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "expectedCandidateCTC"
        );
        setIsFilterActiveExpectedCtc(filterValue?.length !== 0 ? true : false);
        break;

      case "city":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "city"
        );
        setIsFilterActiveCitySubmission(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "phone":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "phone"
        );
        setIsFilterActivePhone(filterValue?.length !== 0 ? true : false);
        break;

      case "state":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "state"
        );
        setIsFilterActiveStateSubmission(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "noticePeriod":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "noticePeriod"
        );
        setIsFilterActiveNoticePeriod( filterValue && filterValue.length > 0 ? filterValue[0] : null );
        break;

      case "address":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "address"
        );
        setIsFilterActiveAddress(filterValue?.length !== 0 ? true : false);
        break;

      case "DOB":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "DOB"
        );
        setIsFilterActiveDOB(filterValue?.length !== 0 ? true : false);
        break;

      case "pancardNumber":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "pancardNumber"
        );
        setIsFilterActivePanCardNumber(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "aadharcardNumber":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "aadharcardNumber"
        );
        setIsFilterActiveAadharCardNumber(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "designation":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "designation"
        );
        setIsFilterActiveDesignation(filterValue?.length !== 0 ? true : false);
        break;

      case "experience":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "experience"
        );
        setIsFilterActiveExperience(filterValue && typeof filterValue?.experience[0] == 'number' ? filterValue?.experience : null);
        break;

      case "gender":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "gender"
        );
        setIsFilterActiveGender(filterValue?.length !== 0 ? true : false);
        break;

      case "workExperience":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "workExperience"
        );
        setIsFilterActiveWorkExperience(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "educationDetails":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "educationDetails"
        );
        setIsFilterActiveEducationDetails(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "submissionBy":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "submissionBy"
        );
        setIsFilterActiveSubmissionBy(filterValue?.length !== 0 ? true : false);
        break;

      case "interviewScheduleDate":
        const { startDate, endDate } = filterValue;
        await handleFilterAllFieldSteps(
          { startDate, endDate },
          contactPage,
          rowsPerContactPage,
          "interviewScheduleDate"
        );
        setIsFilterActiveInterviewScheduleDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;

      case "interviewScheduleTime":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "interviewScheduleTime"
        );
        setIsFilterActiveInterviewScheduleTime(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "interviewScheduleLocation":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "interviewScheduleLocation"
        );
        setIsFilterActiveInterviewScheduleLocation(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "interviewScheduleLink":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "interviewScheduleLink"
        );
        setIsFilterActiveInterviewScheduleLink(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "joinDate":
        await handleFilterAllFieldSteps(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "joinDate"
        );
        setIsFilterActiveJoinDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "expectedJoinDate":
        await handleFilterAllFieldSteps(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "expectedJoinDate"
        );
        setIsFilterActiveExpectedJoinDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "actualCTC":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "actualCTC"
        );
        setIsFilterActiveActualCTC(filterValue?.length !== 0 ? true : false);
        break;
      case "offerCTC":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "offerCTC"
        );
        setIsFilterActiveOfferCTC(filterValue?.length !== 0 ? true : false);
        break;

      case "created_at":
        await handleFilterAllFieldSteps(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          contactPage,
          rowsPerContactPage,
          "created_at"
        );
        setIsFilterActiveDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "updated_at":
        await handleFilterAllFieldSteps(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          contactPage,
          rowsPerContactPage,
          "updated_at"
        );
        setIsFilterActiveUpdatedDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "updatedBy":
        await handleFilterAllFieldSteps(
          filterValue,
          contactPage,
          rowsPerContactPage,
          "updatedBy"
        );
        setIsFilterActiveUpdatedBy(filterValue?.length !== 0 ? true : false);
        break;
      case "interviewRescheduleDate":
        await handleFilterAllFieldSteps(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "interviewRescheduleDate"
        );
        setIsFilterActiveInterviewRescheduleDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "testRescheduleDate":
        await handleFilterAllFieldSteps(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "testRescheduleDate"
        );
        setIsFilterActiveTestRescheduleDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "backoutDate":
        await handleFilterAllFieldSteps(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "backoutDate"
        );
        setIsFilterActiveBackoutDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "source":
        await handleFilterAllFieldSteps(
          filterValue,
          page,
          rowsPerPage,
          "candidateSource"
        );
        setIsFilterActiveSourceSearch(filterValue?.length !== 0 ? true : false);
        break;
        case "submission_id":
          await handleFilterAllFieldSteps(
            filterValue,
            page,
            rowsPerPage,
            "submission_id"
          );
          setIsFilterActiveSubmissionId(
            filterValue?.length !== 0 ? true : false
          );
          break;
      default:
        break;
    }
  };

  const clearFilter = () => {
    setIsFilterActiveSubmissionId(false)
    setSearchSubmissionId("")
    setSearchAllfields("");
    setSearchFname("");
    setSearchBranch([])
    setSearchLname("");
    setSearchJobt("");
    setSearchStatusSubmission([]);
    setSearchCustomer([]);
    setSearchOwnerName([]);
    setIsFilterActiveSourceSearch(false);
    setSearchSourceData([]);
    setSearchCandidatectctype("");
    setSearchCandidatectc("");
    setSearchCitySubmission([]);
    setSearchExpectedCandidateCTC('')    
    setSearchContactName("");
    setSearchstate([]);
    setSearchCandidatectctype("");
    setSearchCandidatectc("");
    setSearchNoticePeriod("");
    setSearchphone("");
    setSearchAddress("");
    setSearchDOB("");
    setSearchAadharCardNumber("");
    setSearchPanCardNumber("");
    setSearchdesignation("");
    setSearchWorkExperience("");
    setSearchEducationDetails("");
    setSearchExperience(null);
    setSearchGender("");
    setSearchInterviewScheduleDate([]);
    setSearchSubmissionDate([]);
    setSearchSubmissionUpdateDate([]);
    setSearchInterviewScheduleLink("");
    setSearchInterviewScheduleLocation("");
    setSearchInterviewScheduleTime("");
    setSearchJoinDate([]);
    setSearchSubmissionBy([]);
    setSearchemail("");
    setActiveField({ name: "", value: "" });
    setSearchActualCTC("");
    setSearchOfferCTC("");
    setSearchExpectedJoinDate([]);
    setSearchUpdatedBy([]);
    setMySubmissionValue("");
    setSearchFullName("");
    setSearchIndustry([]);
    setSearchInterviewRescheduleDate([]);
    setSearchTestRescheduleDate([]);
    setSearchBackoutDate([]);

    setIsFilterActiveBackoutDate(false);
    setIsFilterActiveTestRescheduleDate(false);
    setIsFilterActiveInterviewRescheduleDate(false);
    setIsFilterActiveIndustry(false);
    setIsFilterActiveFullName(false);
    setIsFilterActiveUpdatedBy(false);
    setIsFilterActiveUpdatedDate(false);
    setIsFilterActiveExpectedJoinDate(false);
    setIsFilterActiveOfferCTC(false);
    setIsFilterActiveActualCTC(false);
    setIsFilterActiveEmail(false);
    setIsFilterActiveSubmissionBy(false);
    setIsFilterActiveJoinDate(false);
    setIsFilterActiveInterviewScheduleTime(false);
    setIsFilterActiveInterviewScheduleLocation(false);
    setIsFilterActiveInterviewScheduleLink(false);
    setIsFilterActiveInterviewScheduleDate(false);
    setIsFilterActiveGender(false);
    setIsFilterActiveExperience(false);
    setIsFilterActiveEducationDetails(false);
    setIsFilterActiveWorkExperience(false);
    setIsFilterActiveContactName(false);
    setIsFilterActiveDesignation(false);
    setIsFilterActivePanCardNumber(false);
    setIsFilterActiveAadharCardNumber(false);
    setIsFilterActiveDOB(false);
    setIsFilterActiveAddress(false);
    setIsFilterActivePhone(false);
    setIsFilterActiveNoticePeriod(false);
    setIsFilterActiveExpectedCtc(false);
    setIsFilterActiveExpectedCtctype(false);
    setIsFilterActiveFname(false);
    setIsFilterActiveLname(false);
    setIsFilterActiveJobt(false);
    setIsFilterActiveStatusSubmission(false);
    setIsFilterActiveClient(false);
    setIsFilterActiveOwner(false);
    setIsFilterActiveCtctype(false);
    setIsFilterActiveCtc(false);
    setIsFilterActiveCitySubmission(false);
    setIsFilterActiveStateSubmission(false);
    setIsFilterActiveDate(false);
    setPage(0)
    // getAllSubmissiondata(page, rowsPerPage, moduleData);
    handleFilterAllFieldSteps("",0, rowsPerContactPage, submissionModuleData);
  };

  const fetchModuleData = async () => {
    try {
      // setIsLoading(true);
      const response =
        userRole != "Admin"
          ? await axios.get(
              `${config.apiUrl}/api/getpermissions/${cookie.role}`
            )
          : {};
      const modules = response.data.modules;

      const submissionModule = modules.find(
        (item) => item.module === "submission"
      );
      submissionModule &&
        (await handleFilterAllFieldSteps(
          "",
          contactPage,
          rowsPerContactPage,
          submissionModule?.permissions
        ));
      if (submissionModule) {
        const permissionsData = submissionModule.permissions;
        setSubmissionModuleData(permissionsData);
      }
    } catch (error) {
      error && handleFilterAllFieldSteps("" , contactPage, rowsPerContactPage);
      console.log("Error while fetching module data:", error);
    }
  };
  useEffect(() => {
    cookie?.role && contact?.accountId && fetchModuleData();
  }, [cookie?.role, contact?.accountId]);
 

  const inputElm = document.querySelector("#skill");
  const tagify = new Tagify(inputElm, {
    originalInputValueFormat: (valuesArr) =>
      valuesArr.map((item) => item.value).join(","),
  });

  const inputElm2 = document.querySelector("#question");
  const tagify2 = new Tagify(inputElm2, {
    originalInputValueFormat: (valuesArr2) =>
      valuesArr2.map((item) => item.value).join(","),
  });

  const getCandidateApplicationStatus = async () => {
    await axios
      .get(`${config.apiUrl}/api/get_All_candidate_application_status`)
      .then((response) => {
        const statusData = response.data.data;
        setApplicationStatus(statusData);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.error ||
            "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const minDate = new Date().toISOString().split("T")[0];

  const formatedAutoDate = () => {
    const today = new Date();
    const next30Days = new Date(today);
    next30Days.setDate(next30Days.getDate() + 30);
    const formattedDate = next30Days.toISOString().substr(0, 10);
    formik.setFieldValue("targetdate", formattedDate);
  };
  useEffect(() => {
    ViewPost && formatedAutoDate();
  }, [ViewPost]);

  useEffect(() => {
    const activityOn = `View contact ${contact?.accountOwnerName} `;
    const activityDo = "View Contact";
    const component = "contact";
    const reData ={
      name:contact?.accountOwnerName,
      id:contact._id,
      action:'contactView',
      type:'contact',
      note:null,
    }
    contact.accountOwnerName &&
      userActivity(
        candidate_ownerName,
        userId,
        component,
        activityDo,
        activityOn,
        userRole,
        reData,
      );
  }, [contact?.accountOwnerName]);

  useEffect(() => {
    if (cookie?.token?.length) {
      getContact(id);
    } else {
      history.replace("/");
    }
  }, [cookie]);
  const [industries, setIndustries] = useState([]);
  const getIndustryData = async () => {
    try {
      const response = await axios.get(
        `${config?.apiUrl}/api/get_all_industries`
      );
      setIndustries(response.data);
    } catch (error) {
      console.error("Error fetching industry data:", error);
    }
  };

  useEffect(() => {
    if (cookie?.token?.length) {
      // getAppliedJobdata(contactPage, rowsPerContactPage);
      getIndustryData();
      getAllUserTeams()
      getCandidateApplicationStatus();
    } else {
      history.replace("/");
    }
  }, [cookie, AccountContactId, AccountContactName]);

  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const renderMenu = (menu, defaultCities) => {
    if (defaultCities?.length === 0) {
      return (
        <p style={{ padding: 4, color: "#999", textAlign: "center" }}>
          <SpinnerIcon spin /> loading...
        </p>
      );
    }
    return menu;
  };

const handleCities = async (key) => {
    try {
      const allCities = await getAllCities(key);
      const uniqueCities =
        allCities &&
        Array.from(new Set(allCities?.map((city) => city?.name?.trim()))).map(
          (name) => allCities?.find((city) => city?.name?.trim() === name)
        );
      setDefaultCities(uniqueCities || []);
      // Remove duplicate city names
    } catch (error) {
      toast.error(error?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const handleStates = async () => {
    try {
      if (defaultStates.length == 0) {
        const allStates = await getAllStates();
        // Remove duplicate state names
        const uniqueStates =
          allStates &&
          Array.from(
            new Set(allStates?.map((state) => state?.name?.trim()))
          ).map((name) =>
            allStates?.find((state) => state?.name?.trim() === name)
          );
        setDefaultStates(uniqueStates || []);
      }
    } catch (error) {
      toast.error(error?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  return (
    <Box>
      <ToastContainer />
      <Box
        className={isSidebarOpen ? "content_details" : "content_details_nav"}
      >
        <div
          style={{
            width: "auto",
            margin: "5rem 0rem 1.5rem 0rem",
          }}
        >
          <Flex
            position="relative"
            direction="column"
            align={{ sm: "center" }}
            maxW="auto"
            height="auto"
            mx="auto"
            bg={useColorModeValue("white", "gray.700")}
            shadow={{ sm: "base" }}
            rounded={{ sm: "lg" }}
            padding="7px 20px 7px 20px"
          >
            <Avatar
              mt="-10"
              borderWidth="6px"
              borderColor={useColorModeValue("white", "gray.700")}
              size="xl"
              name={displaycontact?.accountOwnerName}
              className="bg_color"
              color="white"
            />
            <div className="box_details">
              <Box
                textAlign={{ sm: "center" }}
                pt="2"
                style={{ paddingRight: "37px", marginBottom: "1rem" }}
              >
                <Heading
                  size="lg"
                  fontWeight="extrabold"
                  letterSpacing="tight"
                  className="title_color"
                >
                  {!displaycontact?.accountOwnerName
                    ? "N/A"
                    : displaycontact?.accountOwnerName}
                </Heading>
                <Text color={useColorModeValue("gray.600", "gray.400")}>
                  {!displaycontact?.designation
                    ? "N/A"
                    : displaycontact?.designation}
                </Text>
              </Box>
              <hr className="horizontal_line" />
              <div>
                <Text className="title_color" style={{ fontWeight: "bold" }}>
                  <Link
                    to={`/details/accountview/${displaycontact?.accountId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {!displaycontact?.accountName
                      ? "N/A"
                      : displaycontact?.accountName}
                  </Link>
                </Text>
                <Text color={useColorModeValue("gray.600", "gray.400")}>
                  {!displaycontact?.city ? "N/A" : displaycontact?.city},{" "}
                  {!displaycontact?.state ? "N/A" : displaycontact?.state},{" "}
                  {!displaycontact?.country ? "N/A" : displaycontact?.country}
                </Text>
                <Text color={useColorModeValue("gray.600", "gray.400")}>
                  Created On :{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {!displaycontact?.created_at
                      ? "N/A"
                      : new Date(displaycontact?.created_at).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}
                  </span>
                </Text>
              </div>
            </div>
          </Flex>
        </div>
        <Tabs
          style={{
            width: "100%",
          }}
          variant="enclosed"
          defaultIndex={1}
        >
          <TabList style={{ flexWrap: "wrap" }}>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Overview
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Info
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Jobs ({displayClientJobs?.totalJobPosts || 0})
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Submission ({appliedJob?.totalSubmissionCount || 0})
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Box>
                <Row>
                  <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                    <Box
                      as="section"
                      py={{
                        base: "4",
                        md: "8",
                      }}
                      width="auto"
                      backgroundColor="#e3ebf8"
                      boxShadow="lg"
                      borderRadius="10px"
                    >
                      <Heading
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "20px",
                          padding: "10px",
                        }}
                        className="title_color"
                      >
                        Jobs
                      </Heading>
                      <Container>
                        <SimpleGrid
                          columns={{
                            base: 1,
                            md: 3,
                          }}
                          gap={{
                            base: "5",
                            md: "6",
                          }}
                        >
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              Pipelined
                            </Text>
                            <Link
                              to={`/admin/total_Pipelined?id=${AccountContactId}&type=contactsub&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {pipelinedCandidates?.length}
                              </Heading>
                            </Link>
                          </Box>
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              Submitted
                            </Text>
                            <Link
                              to={`/admin/total_Submitted?id=${AccountContactId}&type=contactsub&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {appliedJob?.length}
                              </Heading>
                            </Link>
                          </Box>
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              Interviewed
                            </Text>
                            <Link
                              to={`/admin/total_Interviewed?id=${AccountContactId}&type=contactsub&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {interviewedCandidates?.length}
                              </Heading>
                            </Link>
                          </Box>
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              Selected
                            </Text>
                            <Link
                              to={`/admin/total_SelectedCandidates?id=${AccountContactId}&type=contactsub&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {selectedCandidates?.length}
                              </Heading>
                            </Link>
                          </Box>
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              Accepted
                            </Text>
                            <Link
                              to={`/admin/total_JoinedCandidates?id=${AccountContactId}&type=contactsub&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {joinedCandidates?.length}
                              </Heading>
                            </Link>
                          </Box>
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              Onboarded
                            </Text>
                            <Link
                              to={`/admin/total_OnboardedCandidates?id=${AccountContactId}&type=contactsub&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {onboardedCandidates?.length}
                              </Heading>
                            </Link>
                          </Box>
                        </SimpleGrid>
                      </Container>
                    </Box>
                  </Col>
                  <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                    <Box
                      style={{
                        backgroundColor: "#e3ebf8",
                        padding: "30px",
                        width: "auto",
                        height: "100%",
                        borderRadius: "10px",
                        boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                      }}
                    >
                      <Heading
                        style={{
                          display: "flex",
                          fontSize: "23px",
                          padding: "40px",
                        }}
                        className="title_color"
                      >
                        Jobs Insights
                      </Heading>
                      <Container>
                        <SimpleGrid
                          columns={{
                            base: 1,
                            md: 3,
                          }}
                          gap={{
                            base: "5",
                            md: "6",
                          }}
                        >
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              All Jobs
                            </Text>
                            <Link
                              to={`/admin/total_Job?id=${AccountContactId}&type=contactjob&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {clientJobs?.length}
                              </Heading>
                            </Link>
                          </Box>
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              Active
                            </Text>
                            <Link
                              to={`/admin/total_Active_Job?id=${AccountContactId}&type=contactjob&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {activeJobs?.length}
                              </Heading>
                            </Link>
                          </Box>
                          <Box
                            px={{
                              base: "4",
                              md: "6",
                            }}
                            py={{
                              base: "5",
                              md: "6",
                            }}
                            bg="bg-surface"
                            borderRadius="lg"
                            boxShadow="lg"
                            backgroundColor="white"
                          >
                            <Text fontSize="lg" color="muted">
                              Deactive
                            </Text>
                            <Link
                              to={`/admin/total_Deactive_Job?id=${AccountContactId}&type=contactjob&contactperson=${AccountContactName}`}
                            >
                              <Heading
                                size={{
                                  base: "sm",
                                  md: "md",
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {deactiveJobs?.length}
                              </Heading>
                            </Link>
                          </Box>
                        </SimpleGrid>
                      </Container>
                    </Box>
                  </Col>
                </Row>
              </Box>
            </TabPanel>
            <TabPanel>
              <Card style={{ width: "100%" }}>
                <Card.Header style={{ textAlign: "left", fontWeight: "bold" }}>
                  Personal Details
                </Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item style={{ textAlign: "left" }}>
                    <Container style={{ minWidth: "100%" }}>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Name
                          </Text>
                          <span>
                            {!displaycontact?.accountOwnerName
                              ? "N/A"
                              : displaycontact?.accountOwnerName}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Email
                          </Text>
                          <span>
                            {!displaycontact?.email
                              ? "N/A"
                              : displaycontact?.email}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Phone
                          </Text>
                          <span>
                            {!displaycontact?.phone
                              ? "N/A"
                              : displaycontact?.phone}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Department
                          </Text>
                          <span>
                            {!displaycontact?.department
                              ? "N/A"
                              : displaycontact?.department}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Designation
                          </Text>
                          <span>
                            {!displaycontact?.designation
                              ? "N/A"
                              : displaycontact?.designation}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Country
                          </Text>
                          <span>
                            {!displaycontact?.country
                              ? "N/A"
                              : displaycontact?.country}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            State
                          </Text>
                          <span>
                            {!displaycontact?.state
                              ? "N/A"
                              : displaycontact?.state}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            City
                          </Text>
                          <span>
                            {!displaycontact?.city
                              ? "N/A"
                              : displaycontact?.city}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Street
                          </Text>
                          <span>
                            {!displaycontact?.street
                              ? "N/A"
                              : displaycontact?.street}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Pincode
                          </Text>
                          <span>
                            {!displaycontact?.pincode
                              ? "N/A"
                              : displaycontact?.pincode}
                          </span>
                        </Col>
                      </Row>
                    </Container>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
              <Box className="btns_box">
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "1rem",
                  }}
                >
                  <button
                    className="candi_btns"
                    onClick={() => {
                      handleEditContactShow(setContactId(contact._id));
                      getConatct(contact);
                    }}
                  >
                    Edit
                  </button>
                </Box>
              </Box>
              {/* Modal for Edit Contact */}
              <div className="model-box-view">
                <Modal
                  show={editContact}
                  onHide={handleEditContactClose}
                  backdrop="static"
                  keyboard={false}
                  size="lg"
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="usertitle">
                      Edit Contact
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <h1
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.3rem",
                        padding: "0.3rem",
                        paddingBottom: "15px",
                      }}
                      className="usertitle"
                    >
                      Contact Information
                    </h1>
                    <form
                      id="addaccount"
                      onSubmit={editFormikContact.handleSubmit}
                    >
                      <Container>
                        <Row>
                          <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              Name
                            </FormLabel>
                            <Input
                              variant="auth"
                              fontSize="sm"
                              ms="4px"
                              type="text"
                              placeholder="Name"
                              size="lg"
                              name="accountOwnerName"
                              value={editFormikContact.values.accountOwnerName}
                              onChange={editFormikContact.handleChange}
                              onBlur={editFormikContact.handleBlur}
                              style={{
                                width: "100%",
                                height: "37px",
                                border:
                                  editFormikContact.touched.accountOwnerName &&
                                  editFormikContact.errors.accountOwnerName
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                            />
                            {editFormikContact.touched.accountOwnerName &&
                            editFormikContact.errors.accountOwnerName ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.accountOwnerName}
                              </div>
                            ) : null}
                          </Col>
                          <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              Email
                            </FormLabel>
                            <Input
                              variant="auth"
                              fontSize="sm"
                              ms="4px"
                              type="text"
                              placeholder="Email"
                              size="lg"
                              name="email"
                              value={editFormikContact.values.email}
                              onChange={editFormikContact.handleChange}
                              onBlur={editFormikContact.handleBlur}
                              style={{
                                width: "100%",
                                height: "37px",
                                border:
                                  editFormikContact.touched.email &&
                                  editFormikContact.errors.email
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                            />
                            {editFormikContact.touched.email &&
                            editFormikContact.errors.email ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.email}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              Designation
                            </FormLabel>
                            <Input
                              variant="auth"
                              fontSize="sm"
                              ms="4px"
                              type="text"
                              placeholder="Designation"
                              size="lg"
                              name="designation"
                              value={editFormikContact.values.designation}
                              onChange={editFormikContact.handleChange}
                              onBlur={editFormikContact.handleBlur}
                              style={{
                                width: "100%",
                                height: "37px",
                                border:
                                  editFormikContact.touched.designation &&
                                  editFormikContact.errors.designation
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                            />
                            {editFormikContact.touched.designation &&
                            editFormikContact.errors.designation ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.designation}
                              </div>
                            ) : null}
                          </Col>
                          <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              Department
                            </FormLabel>
                            <Input
                              variant="auth"
                              fontSize="sm"
                              ms="4px"
                              type="text"
                              placeholder="Department"
                              size="lg"
                              name="department"
                              value={editFormikContact.values.department}
                              onChange={editFormikContact.handleChange}
                              onBlur={editFormikContact.handleBlur}
                              style={{
                                width: "100%",
                                height: "37px",
                                border:
                                  editFormikContact.touched.department &&
                                  editFormikContact.errors.department
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                            />
                            {editFormikContact.touched.department &&
                            editFormikContact.errors.department ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.department}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              Phone
                            </FormLabel>
                            <div className="contactphone">
                              <PhoneInput
                                country={"in"}
                                containerStyle={{
                                  border:
                                    editFormikContact.touched.phone &&
                                    editFormikContact.errors.phone
                                      ? "1px solid red"
                                      : "",
                                  borderRadius:
                                    editFormikContact.touched.phone &&
                                    editFormikContact.errors.phone
                                      ? "4px"
                                      : "",
                                }}
                                dropdownStyle={{
                                  border:
                                    editFormikContact.touched.phone &&
                                    editFormikContact.errors.phone
                                      ? "1px solid red"
                                      : "1px solid #ccc",
                                }}
                                onChange={(phone) => {
                                  setContact({ ...contact, phone: phone });
                                  const phoneNumberWithPlus = `+${phone}`;

                                  editFormikContact.setFieldValue(
                                    "phone",
                                    phoneNumberWithPlus
                                  );
                                }}
                                value={editFormikContact.values.phone}
                                onBlur={editFormikContact.handleBlur}
                              />
                              {editFormikContact.touched.phone &&
                              editFormikContact.errors.phone ? (
                                <div style={{ color: "red", fontSize: "14px" }}>
                                  {editFormikContact.errors.phone}
                                </div>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              External Phone
                            </FormLabel>
                            <div className="contactphone">
                              <PhoneInput
                                country={"in"}
                                onChange={(externalphone) => {
                                  setContact({
                                    ...contact,
                                    externalphone: externalphone,
                                  });
                                  const phoneNumberWithPlus = `+${externalphone}`;

                                  editFormikContact.setFieldValue(
                                    "externalphone",
                                    phoneNumberWithPlus
                                  );
                                }}
                                value={editFormikContact.values.externalphone}
                                onBlur={editFormikContact.handleBlur}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              Country
                            </FormLabel>
                            <Select
                              options={Country.getAllCountries()}
                              placeholder="Select Country"
                              name="country"
                              classNamePrefix={
                                editFormikContact.touched.country &&
                                editFormikContact.errors.country &&
                                "democlass"
                              }
                              styles={{
                                border:
                                  editFormikContact.touched.country &&
                                  editFormikContact.errors.country
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                              getOptionLabel={(options) => {
                                return options["name"];
                              }}
                              getOptionValue={(options) => {
                                return options["name"];
                              }}
                              value={
                                editFormikContact.values.country &&
                                selectedCountry
                              }
                              onBlur={editFormikContact.handleBlur}
                              onChange={(item) => {
                                setSelectedCountry(item);
                                setContact({ ...contact, country: item.name });
                                editFormikContact.setFieldValue(
                                  "country",
                                  item.name
                                );
                              }}
                            />
                            {editFormikContact.touched.country &&
                            editFormikContact.errors.country ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.country}
                              </div>
                            ) : null}
                          </Col>
                          <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              State
                            </FormLabel>
                            <Select
                              options={State?.getStatesOfCountry(
                                selectedCountry?.isoCode
                              )}
                              placeholder="Select State"
                              getOptionLabel={(options) => {
                                return options["name"];
                              }}
                              getOptionValue={(options) => {
                                return options["name"];
                              }}
                              classNamePrefix={
                                editFormikContact.touched.state &&
                                editFormikContact.errors.state &&
                                "democlass"
                              }
                              styles={{
                                border:
                                  editFormikContact.touched.state &&
                                  editFormikContact.errors.state
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                              name="state"
                              value={
                                editFormikContact.values.state && selectedState
                              }
                              onChange={(item) => {
                                if (selectedState?.isoCode !== item.isoCode) {
                                  setSelectedState(item);
                                  setSelectedCity(null);
                                  setContact({ ...contact, state: item.name });
                                  editFormikContact.setFieldValue(
                                    "state",
                                    item.name
                                  );
                                  editFormikContact.setFieldValue("city", "");
                                }
                              }}
                              onBlur={editFormikContact.handleBlur}
                            />
                            {editFormikContact.touched.state &&
                            editFormikContact.errors.state ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.state}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              City
                            </FormLabel>
                            <Select
                              options={City.getCitiesOfState(
                                selectedState?.countryCode,
                                selectedState?.isoCode
                              )}
                              placeholder="Select City"
                              getOptionLabel={(options) => {
                                return options["name"];
                              }}
                              getOptionValue={(options) => {
                                return options["name"];
                              }}
                              classNamePrefix={
                                editFormikContact.touched.city &&
                                editFormikContact.errors.city &&
                                "democlass"
                              }
                              styles={{
                                border:
                                  editFormikContact.touched.city &&
                                  editFormikContact.errors.city
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                              name="city"
                              value={
                                editFormikContact.values.city && selectedCity
                              }
                              onChange={(item) => {
                                setSelectedCity(item);
                                setContact({ ...contact, city: item.name });
                                editFormikContact.setFieldValue(
                                  "city",
                                  item.name
                                );
                              }}
                              onBlur={editFormikContact.handleBlur}
                            />
                            {editFormikContact.touched.city &&
                            editFormikContact.errors.city ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.city}
                              </div>
                            ) : null}
                          </Col>
                          <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              Street
                            </FormLabel>
                            <Input
                              variant="auth"
                              fontSize="sm"
                              ms="4px"
                              type="text"
                              placeholder="Street"
                              size="lg"
                              name="street"
                              value={editFormikContact.values.street}
                              onChange={editFormikContact.handleChange}
                              onBlur={editFormikContact.handleBlur}
                              style={{
                                width: "100%",
                                height: "37px",
                                border:
                                  editFormikContact.touched.street &&
                                  editFormikContact.errors.street
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                            />
                            {editFormikContact.touched.street &&
                            editFormikContact.errors.street ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.street}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                            <FormLabel
                              ms="4px"
                              fontSize="sm"
                              fontWeight="400"
                              fontFamily="Roboto"
                              color="#000000"
                            >
                              Pincode
                            </FormLabel>
                            <Input
                              variant="auth"
                              fontSize="sm"
                              ms="4px"
                              type="text"
                              placeholder="Pincode"
                              size="lg"
                              name="pincode"
                              value={editFormikContact.values.pincode}
                              onChange={editFormikContact.handleChange}
                              onBlur={editFormikContact.handleBlur}
                              style={{
                                width: "100%",
                                height: "37px",
                                border:
                                  editFormikContact.touched.pincode &&
                                  editFormikContact.errors.pincode
                                    ? "1px solid red"
                                    : "1px solid #ccc",
                              }}
                            />
                            {editFormikContact.touched.pincode &&
                            editFormikContact.errors.pincode ? (
                              <div style={{ color: "red", fontSize: "14px" }}>
                                {editFormikContact.errors.pincode}
                              </div>
                            ) : null}
                          </Col>
                          <Col lg={6} md={6}></Col>
                        </Row>
                      </Container>
                      <Modal.Footer
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Button
                          className="cancel"
                          type="button"
                          onClick={handleEditContactClose}
                        >
                          Cancel
                        </Button>
                        <Button type="submit" className="btn_bg_color">
                          Update
                        </Button>
                      </Modal.Footer>
                    </form>
                  </Modal.Body>
                </Modal>
              </div>
              {/* Modal for Batch Send Email Jobs*/}
              <ComposeMailForm
                ViewSendMail={ViewSendMail}
                handleSendMailClose={handleSendMailClose}
                SetToemail={SetToemail}
                SetCcemail={SetCcemail}
                SetBccemail={SetBccemail}
                SetSubject={SetSubject}
                SetMailMessage={SetMailMessage}
                checked={checked}
                endPoint={"/api/SelectJob_EmailSend"}
              />

              {/* Modal for Batch Send Email Submissions*/}
              <ComposeMailForm
                ViewSendMail={ViewSendMailSub}
                handleSendMailClose={handleSendMailSubClose}
                SetToemail={SetToemail}
                SetCcemail={SetCcemail}
                SetBccemail={SetBccemail}
                SetSubject={SetSubject}
                SetMailMessage={SetMailMessage}
                checked={checked}
                endPoint={"/api/SelectCandidate_EmailSend"}
              />
            </TabPanel>
            {/* Job Table */}
            <TabPanel>
              <div className="table_box">
                <Row>
                  <Col lg={8}>
                    <Box sx={{ display: "flex", gap: 3, width: "100%" }}>
                      <InputGroup>
                        <InputLeftElement
                          children={
                            <img
                              src={Searchicon}
                              width="18px"
                              height="18px"
                              style={{ cursor: "pointer" }}
                            />
                          }
                        />
                        <Input
                          type="text"
                          id="searchAllfields"
                          placeholder="Search Job Title, Skill, City..."
                          value={searchAllfields}
                          onChange={(e) => {
                            setSearchAllfields(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleFilterAllFieldStep(
                                searchAllfields,
                                page,
                                rowsPerPage,
                                "text"
                              );
                            }
                          }}
                          style={{
                            height: "37px",
                            padding: "9px",
                            paddingLeft: "2.6rem",
                            color: "#7B9AAA",
                            fontFamily: "Roboto",
                            fontWeight: "500",
                            lineHeight: "19px",
                            fontSize: "15px",
                          }}
                        />
                        {searchAllfields.length !== 0 && (
                          <InputRightElement
                            children={
                              <CloseButton
                                size="md"
                                sx={{
                                  background: "#fff",
                                  color: "rgb(123, 154, 170)",
                                }}
                                _hover={{ background: "" }}
                                _focus={{ boxShadow: "none" }}
                              />
                            }
                            onClick={() => {
                              setSearchAllfields("");
                              setPage(0);
                              setRowsPerPage(10);
                              handleFilterAllFieldStep(
                                "",
                                page,
                                rowsPerPage,
                                "text"
                              );
                            }}
                          />
                        )}
                      </InputGroup>
                      {(activeField.name || searchAllfields) && (
                        <Button
                          className="bg_color"
                          onClick={() => clearJobFilter()}
                          style={{
                            color: "white",
                            border: "1px solid #d7d7d7",
                            fontWeight: "500",
                            letterSpacing: "1px",
                            fontSize: "14px",
                          }}
                        >
                          Reset
                        </Button>
                      )}
                    </Box>
                  </Col>
                  <Col lg={4}>
                    <Box className="button_box">
                      <Button
                        style={{
                          color: "white",
                          border: "1px solid #d7d7d7",
                          fontWeight: "500",
                          letterSpacing: "1px",
                          fontSize: "14px",
                        }}
                        className="bg_color"
                        onClick={() => {
                          handlePostShow();
                          formik.setFieldValue(
                            "ownerPhone",
                            localStorage.getItem("mobileNo")
                          );
                        }}
                      >
                        Add Job
                      </Button>
                    </Box>
                  </Col>
                </Row>
              </div>
              <div
                style={{
                  boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                }}
              >
                <Paper style={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer style={{ maxHeight: 680 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow sx={{ textAlignLast: "center" }}>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "50px",
                            }}
                          >
                            <Box className="table_menu">
                              <Checkbox
                                size="md"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    SetIschecked((oldarr) => [
                                      ...oldarr,
                                      ...displayClientJobs?.map((value) => ({
                                        id: value?._id,
                                        email: value?.clientId?.email,
                                      })),
                                    ]);
                                  } else {
                                    SetIschecked([]);
                                  }
                                }}
                              />
                              <Menu>
                                <MenuButton>
                                  <ExpandMoreIcon
                                    style={{ cursor: "pointer" }}
                                  />
                                </MenuButton>
                                <MenuList
                                  style={{ position: "absolute", top: "12px" }}
                                >
                                  <MenuItem
                                    icon={<MailOutlineIcon />}
                                    onClick={() => {
                                      handleSendMailShow();
                                    }}
                                  >
                                    Batch Send Mail
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Box>
                          </TableCell>
                          <TableCell
                            className="tabelheadtitle"
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Job Id
                            <OverlayTrigger
                              {...popOverConfig("job_id")}
                              overlay={
                                <Popover id="popover-basic">
                                  <Popover.Body>
                                    <InputTextSearchBox
                                      filterData={filterJobData}
                                      inputState={searchJobId}
                                      fieldName={"job_id"}
                                      setInputState={setSearchJobId}
                                      setActiveField={setActiveField}
                                      activeFieldName={"job_id"}
                                      isFilterActiveState={isFilterActiveJobId}
                                      inputPlaceholder={"Search Job Id"}
                                    />
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveJobId ? (
                                <FilterAltIcon
                                  style={{
                                    cursor: "pointer",
                                  }}
                                />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            className="tabelheadtitle"
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Job Title
                            <OverlayTrigger
                              {...popOverConfig("jobTitle")}
                              overlay={
                                <Popover id="popover-basic">
                                  <Popover.Body>
                                    <InputTextSearchBox
                                      filterData={filterJobData}
                                      inputState={searchjobtitle}
                                      fieldName={"jobTitle"}
                                      setInputState={setSearchJobtitle}
                                      setActiveField={setActiveField}
                                      activeFieldName={"jobTitle"}
                                      isFilterActiveState={isFilterActiveJobt}
                                      inputPlaceholder={"Search Job Title"}
                                    />
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveJobt ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Client
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Branch
                            {/* {branch == undefined && ( */}
                            <OverlayTrigger
                              {...popOverConfig("branchTabJob")}
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  style={{ maxWidth: "100%" }}
                                >
                                  <Popover.Body
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <CheckFilter
                                      filterData={filterJobData}
                                      setActiveField={setActiveField}
                                      handlePopOverClose={handlePopOverClose}
                                      field={"branchTabJob"}
                                      placeholder={"Select Branch"}
                                      value={searchJobTabBranch}
                                      setValue={setSearchJobTabBranch}
                                      data={clientBranch?.map((el)=>{
                                          return {
                                            label: el?.branchName,
                                            value: el?._id,
                                          }
                                        })}
                                      isFilter={isFilterActiveTabJobBranch}
                                      setIsFilter={setIsFilterActiveTabJobBranch}
                                    />
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveTabJobBranch ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                            {/* )} */}
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "160px",
                            }}
                          >
                            Contact Person
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            City
                            <OverlayTrigger
                              {...popOverConfig("city")}
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  style={{ maxWidth: "100%" }}
                                >
                                  <Popover.Body>
                                    <Box sx={{ display: "flex", gap: 5 }}>
                                      <CheckFilter
                                        filterData={filterJobData}
                                        setActiveBranchField={setActiveField}
                                        handlePopOverClose={handlePopOverClose}
                                        field={"branchCity"}
                                        placeholder={"Select Cities"}
                                        value={searchcity}
                                        setValue={setSearchCity}
                                        data={defaultCities?.map((city) => ({
                                          label: city?.name?.trim(),
                                          value: city?.name?.trim(),
                                        }))}
                                        isFilter={isFilterActiveCity}
                                        setIsFilter={
                                          setIsFilterActiveCity
                                        }
                                        fetchData={handleCities}
                                        searchKeyword={searchKeywordCity}
                                        setSearchKeyword={setSearchKeywordCity}
                                        debouncingFunction={handleCities}
                                      />
                                    </Box>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveCity ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "160px",
                            }}
                          >
                            State
                            <OverlayTrigger
                              {...popOverConfig("state")}
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  style={{ maxWidth: "100%" }}
                                >
                                  <Popover.Body>
                                    <Box sx={{ display: "flex", gap: 5 }}>
                                      <CheckPicker
                                        data={defaultStates?.map((state) => ({
                                          label: state?.name?.trim(),
                                          value: state?.name?.trim(),
                                        }))}
                                        style={{ width: 224 }}
                                        menuClassName="reactMultiSelectMenu"
                                        value={searchstate}
                                        renderMenu={(menu) =>
                                          renderMenu(menu, defaultStates)
                                        }
                                        onOpen={handleStates}
                                        onClean={() => {
                                          if (isFilterActiveState) {
                                            filterJobData("", "state");
                                            setIsFilterActiveState(false);
                                            setSearchState([]);
                                            setActiveField({
                                              name: "state",
                                              value: "",
                                            });
                                          }
                                        }}
                                        onChange={(selectedOption) => {
                                          setSearchState(selectedOption);
                                          setActiveField({
                                            name: "state",
                                            value: selectedOption,
                                          });
                                        }}
                                        placeholder="Select States"
                                      />
                                      <IconButton
                                        color={"#fff"}
                                        background={"var(--main-bg-color)"}
                                        aria-label="Search date range"
                                        _hover={{
                                          background: "var(--main-bg-color)",
                                        }}
                                        isDisabled={searchstate?.length == 0}
                                        size={"sm"}
                                        icon={<FiSearch />}
                                        onClick={() => {
                                          filterJobData(searchstate, "state");
                                        }}
                                      />
                                    </Box>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveState ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Status
                            <OverlayTrigger
                              {...popOverConfig("status")}
                              overlay={
                                <Popover id="popover-basic">
                                  <Popover.Body>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      style={{
                                        width: "auto",
                                      }}
                                    >
                                      <select
                                        className="form-control"
                                        id="searchstatus"
                                        value={searchstatus}
                                        onChange={(e) => {
                                          setSearchStatus(e.target.value);
                                          setActiveField({
                                            name: "status",
                                            value: e.target.value,
                                          });
                                          filterJobData(
                                            e.target.value,
                                            "status"
                                          );
                                        }}
                                        style={{
                                          height: "37px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <option disabled={true} value="">
                                          Status
                                        </option>
                                        <option value="Active">Active</option>
                                        <option value="Deactive">
                                          Deactive
                                        </option>
                                        <option value="On Hold">On Hold</option>
                                        <option value="Cancelled">
                                          Cancelled
                                        </option>
                                        <option value="Target Date Expired">
                                          Target Date Expired
                                        </option>
                                      </select>
                                      {isFilterActiveStatus && (
                                        <CloseButton
                                          size="sm"
                                          onClick={() => {
                                            filterJobData("", "status");
                                            setSearchStatus("");
                                            setActiveField({
                                              name: "status",
                                              value: "",
                                            });
                                          }}
                                          _focus={{ boxShadow: "none" }}
                                        />
                                      )}
                                    </Box>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveStatus ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Owner
                            <OverlayTrigger
                              {...popOverConfig("owner_name")}
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  style={{ maxWidth: "100%" }}
                                >
                                  <Popover.Body>
                                    <Box sx={{ display: "flex", gap: 5 }}>
                                      <CheckPicker
                                        data={userNames.map((user) => ({
                                          label: `${user.firstName?.trim()} ${user.lastName?.trim()}`,
                                          value: user?._id,
                                        }))}
                                        style={{ width: 224 }}
                                        menuClassName="reactMultiSelectMenu"
                                        value={searchJobOwner}
                                        onClean={() => {
                                          if (isFilterJobActiveOwner) {
                                            filterJobData("", "owner_name");
                                            setIsFilterJobActiveOwner(false);
                                          }
                                        }}
                                        onChange={(selectedOption) => {
                                          setSearchJobOwner(selectedOption);
                                          setActiveField({
                                            name: "job_ownerName",
                                            value: selectedOption,
                                          });
                                        }}
                                        placeholder="Select Users"
                                      />
                                      <IconButton
                                        color={"#fff"}
                                        background={"var(--main-bg-color)"}
                                        aria-label="Search date range"
                                        _hover={{
                                          background: "var(--main-bg-color)",
                                        }}
                                        size={"sm"}
                                        icon={<FiSearch />}
                                        isDisabled={searchJobOwner?.length == 0}
                                        onClick={() => {
                                          filterJobData(
                                            searchJobOwner,
                                            "owner_name"
                                          );
                                        }}
                                      />
                                    </Box>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterJobActiveOwner ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "150px",
                            }}
                          >
                            Account Manager
                            <OverlayTrigger
                              {...popOverConfig("accountmanager")}
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  style={{ maxWidth: "100%" }}
                                >
                                  <Popover.Body>
                                    <Box sx={{ display: "flex", gap: 5 }}>
                                      <CheckPicker
                                        data={userNames.map((user) => ({
                                          label: `${user.firstName?.trim()} ${user.lastName?.trim()}`,
                                          value: user?._id,
                                        }))}
                                        style={{ width: 224 }}
                                        menuClassName="reactMultiSelectMenu"
                                        value={searchaccountmanager}
                                        onClean={() => {
                                          if (isFilterActiveActMang) {
                                            filterJobData("", "accountmanager");
                                            setIsFilterActiveActMang(false);
                                          }
                                        }}
                                        onChange={(selectedOption) => {
                                          setSearchAccountmanager(
                                            selectedOption
                                          );
                                          setActiveField({
                                            name: "accountmanager",
                                            value: selectedOption,
                                          });
                                        }}
                                        placeholder="Select Users"
                                      />
                                      <IconButton
                                        color={"#fff"}
                                        background={"var(--main-bg-color)"}
                                        aria-label="Search date range"
                                        _hover={{
                                          background: "var(--main-bg-color)",
                                        }}
                                        size={"sm"}
                                        icon={<FiSearch />}
                                        isDisabled={
                                          searchaccountmanager?.length == 0
                                        }
                                        onClick={() => {
                                          filterJobData(
                                            searchaccountmanager,
                                            "accountmanager"
                                          );
                                        }}
                                      />
                                    </Box>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveActMang ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Recruiter
                            <OverlayTrigger
                              {...popOverConfig("recruiter")}
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  style={{ maxWidth: "100%" }}
                                >
                                  <Popover.Body>
                                    <Box sx={{ display: "flex", gap: 5 }}>
                                      <CheckPicker
                                        data={userNames.map((user) => ({
                                          label: `${user.firstName?.trim()} ${user.lastName?.trim()}`,
                                          value: user?._id,
                                        }))}
                                        style={{ width: 224 }}
                                        menuClassName="reactMultiSelectMenu"
                                        value={searchrecruiter}
                                        onClean={() => {
                                          if (isFilterActiveRecruiter) {
                                            filterJobData("", "recruiter");
                                            setIsFilterActiveRecruiter(false);
                                          }
                                        }}
                                        onChange={(selectedOption) => {
                                          setSearchRecruiter(selectedOption);
                                          setActiveField({
                                            name: "recruiter",
                                            value: selectedOption,
                                          });
                                        }}
                                        placeholder="Select Users"
                                      />
                                      <IconButton
                                        color={"#fff"}
                                        background={"var(--main-bg-color)"}
                                        aria-label="Search date range"
                                        _hover={{
                                          background: "var(--main-bg-color)",
                                        }}
                                        size={"sm"}
                                        icon={<FiSearch />}
                                        isDisabled={
                                          searchrecruiter?.length == 0
                                        }
                                        onClick={() => {
                                          filterJobData(
                                            searchrecruiter,
                                            "recruiter"
                                          );
                                        }}
                                      />
                                    </Box>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveRecruiter ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "160px",
                            }}
                          >
                            Team Leader
                            <OverlayTrigger
                              {...popOverConfig("teamleader")}
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  style={{ maxWidth: "100%" }}
                                >
                                  <Popover.Body>
                                    <Box sx={{ display: "flex", gap: 5 }}>
                                      <CheckPicker
                                        data={userNames.map((user) => ({
                                          label: `${user.firstName?.trim()} ${user.lastName?.trim()}`,
                                          value: user?._id,
                                        }))}
                                        style={{ width: 224 }}
                                        menuClassName="reactMultiSelectMenu"
                                        value={searchteamleader}
                                        onClean={() => {
                                          if (isFilterActiveTlead) {
                                            filterJobData("", "teamleader");
                                            setIsFilterActiveTlead(false);
                                          }
                                        }}
                                        onChange={(selectedOption) => {
                                          setSearchTeamleader(selectedOption);
                                          setActiveField({
                                            name: "teamleader",
                                            value: selectedOption,
                                          });
                                        }}
                                        placeholder="Select Users"
                                      />
                                      <IconButton
                                        color={"#fff"}
                                        background={"var(--main-bg-color)"}
                                        aria-label="Search date range"
                                        _hover={{
                                          background: "var(--main-bg-color)",
                                        }}
                                        size={"sm"}
                                        icon={<FiSearch />}
                                        isDisabled={
                                          searchteamleader?.length == 0
                                        }
                                        onClick={() => {
                                          filterJobData(
                                            searchteamleader,
                                            "teamleader"
                                          );
                                        }}
                                      />
                                    </Box>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveTlead ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Skill
                            <OverlayTrigger
                              {...popOverConfig("skill")}
                              overlay={
                                <Popover id="popover-basic">
                                  <Popover.Body>
                                    <InputTextSearchBox
                                      filterData={filterJobData}
                                      inputState={searchskill}
                                      fieldName={"skill"}
                                      setInputState={setSearchSkill}
                                      setActiveField={setActiveField}
                                      activeFieldName={"skill"}
                                      isFilterActiveState={isFilterActiveSkill}
                                      inputPlaceholder={"Search Skills"}
                                    />
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveSkill ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "#718096",
                              fontWeight: "bold",
                              minWidth: "130px",
                            }}
                          >
                            Published Date
                            <OverlayTrigger
                              {...popOverConfig("created_at")}
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  style={{ maxWidth: "460px" }}
                                >
                                  <Popover.Body
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 5,
                                          marginBottom: 2,
                                          alignItems: "center",
                                        }}
                                      >
                                        <InputGroup>
                                          <Input
                                            type="date"
                                            id="startDate"
                                            placeholder="From Date..."
                                            value={startDate}
                                            onChange={(e) => {
                                              setStartDate(e.target.value);
                                              const filterDate = {
                                                startDate: e.target.value,
                                                endDate: endDate,
                                              };
                                              setActiveField({
                                                name: "created_at",
                                                value: filterDate,
                                              });
                                            }}
                                            style={{
                                              height: "37px",
                                              color: "#7B9AAA",
                                              fontFamily: "Roboto",
                                              fontWeight: "500",
                                              lineHeight: "19px",
                                              fontSize: "15px",
                                            }}
                                          />
                                        </InputGroup>
                                        <span
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-evenly",
                                          }}
                                        >
                                          {" "}
                                          -{" "}
                                        </span>
                                        <InputGroup>
                                          <Input
                                            type="date"
                                            id="endJoinDate"
                                            placeholder="To Date..."
                                            value={endDate}
                                            min={startDate}
                                            onChange={(e) => {
                                              setEndDate(e.target.value);
                                              const filterDate = {
                                                startDate: startDate,
                                                endDate: e.target.value,
                                              };
                                              setActiveField({
                                                name: "created_at",
                                                value: filterDate,
                                              });
                                            }}
                                            style={{
                                              height: "37px",
                                              color: "#7B9AAA",
                                              fontFamily: "Roboto",
                                              fontWeight: "500",
                                              lineHeight: "19px",
                                              fontSize: "15px",
                                            }}
                                          />
                                        </InputGroup>
                                        {startDate && endDate && (
                                          <IconButton
                                            color={"#fff"}
                                            background={"var(--main-bg-color)"}
                                            aria-label="Search date range"
                                            _hover={{
                                              background:
                                                "var(--main-bg-color)",
                                            }}
                                            size={"sm"}
                                            icon={<FiSearch />}
                                            onClick={() => {
                                              const filterDate = {
                                                startDate: startDate,
                                                endDate: endDate,
                                              };
                                              filterJobData(filterDate, "date");
                                            }}
                                          />
                                        )}
                                        {isFilterActiveJdate && (
                                          <CloseButton
                                            size="sm"
                                            onClick={() => {
                                              setEndDate("");
                                              setStartDate("");
                                              setActiveField({
                                                name: "created_at",
                                                value: {
                                                  startDate: "",
                                                  endDate: "",
                                                },
                                              });
                                              handleFilterAllFieldStep(
                                                {
                                                  startDate: "",
                                                  endDate: "",
                                                },
                                                page,
                                                rowsPerPage,
                                                "created_at"
                                              );
                                              setIsFilterActiveJdate(false);
                                              handlePopOverClose(false);
                                            }}
                                            _focus={{ boxShadow: "none" }}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              {isFilterActiveJdate ? (
                                <FilterAltIcon style={{ cursor: "pointer" }} />
                              ) : (
                                <FilterListIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </OverlayTrigger>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {jobLoading ? (
                          <>
                            <TableRow>
                              <TableCell colSpan={10}>
                                <Loadar />
                              </TableCell>
                            </TableRow>
                          </>
                        ) : (
                          <>
                            {displayClientJobs.length == 0 ? (
                              <>
                                <TableRow>
                                  <TableCell colSpan={10}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <img
                                        src={NotFound}
                                        alt="NotFound"
                                        style={{ width: "16rem" }}
                                      />
                                      <p>
                                        No Records Found! Please try again....
                                      </p>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              </>
                            ) : (
                              <>
                                {displayClientJobs &&
                                  displayClientJobs.map((value, index) => (
                                    <TableRow key={value._id}>
                                      <TableCell className="nowrap_content">
                                        <Box className="table_menu">
                                          <Checkbox
                                            size="md"
                                            value={value?._id}
                                            onChange={(e) => {
                                              if (e.target.checked) {
                                                SetIschecked((oldarr) => [
                                                  ...oldarr,
                                                  {
                                                    id: e.target?.value,
                                                    email:
                                                      value?.clientId?.email,
                                                  },
                                                ]);
                                              } else {
                                                SetIschecked((olarr) => {
                                                  return olarr.filter(
                                                    (value) =>
                                                      e.target?.value !==
                                                      value?.id
                                                  );
                                                });
                                              }
                                            }}
                                            isChecked={checked
                                              ?.map((val) => val?.id)
                                              .includes(value?._id)}
                                          />
                                          <Menu>
                                            <MenuButton>
                                              <MoreVertIcon
                                                style={{
                                                  cursor: "pointer",
                                                  fontSize: "20px",
                                                }}
                                              />
                                            </MenuButton>
                                            <MenuList
                                              style={{
                                                position: "absolute",
                                                top: "2px",
                                                zIndex: "100",
                                              }}
                                            >
                                              <MenuItem
                                                icon={
                                                  <ModeEditIcon
                                                    style={{ fontSize: "20px" }}
                                                  />
                                                }
                                                onClick={() => {
                                                  setJobBranch({ label: value?.branch?.branchName, value: value?.branch?._id });
                                                  handleEditShow(
                                                    setJobpost(value),
                                                    setJobId(value._id),
                                                    getJobs(value)
                                                  );
                                                  
                                                }}
                                              >
                                                Edit
                                              </MenuItem>
                                              <MenuItem
                                                icon={
                                                  <DeleteIcon
                                                    style={{ fontSize: "20px" }}
                                                  />
                                                }
                                                onClick={() => {
                                                  handleDeleteJobShow(
                                                    setJobpost(value),
                                                    setJobId(value?._id)
                                                  );
                                                }}
                                              >
                                                Delete
                                              </MenuItem>
                                            </MenuList>
                                          </Menu>
                                          <div style={{ position: "relative" }}>
                                            {value?.noteCount !== 0 && (
                                              <div
                                                style={{
                                                  color: "white",
                                                  height: "auto",
                                                  width: "auto",
                                                  textAlign: "center",
                                                  position: "absolute",
                                                  marginLeft: "11px",
                                                  marginTop: "-10px",
                                                  borderRadius: "50px",
                                                  fontSize: "10px",
                                                  padding: "1px 5px",
                                                }}
                                                className="bg_color"
                                              >
                                                <span>{value?.noteCount}</span>
                                              </div>
                                            )}
                                            <Tooltip
                                              hasArrow
                                              label={
                                                value?.notes[
                                                  value?.notes.length - 1
                                                ]?.jobNote
                                              }
                                              bg="gray.300"
                                              color="black"
                                            >
                                              <button
                                                className="note_btn"
                                                onClick={() => {
                                                  handleJobNoteShow();
                                                  setNote({
                                                    ...note,
                                                    jobId: value?._id,
                                                    name: value?.jobtitle,
                                                  });
                                                  getJobNotes(
                                                    value?._id,
                                                    setGetNotes,
                                                    setNotesLoading
                                                  );
                                                }}
                                              >
                                                N
                                              </button>
                                            </Tooltip>
                                          </div>
                                          <div style={{ position: "relative" }}>
                                            {value?.submissionCount !== 0 && (
                                              <div
                                                style={{
                                                  color: "white",
                                                  height: "auto",
                                                  width: "auto",
                                                  textAlign: "center",
                                                  position: "absolute",
                                                  marginLeft: "11px",
                                                  marginTop: "-10px",
                                                  borderRadius: "50px",
                                                  fontSize: "10px",
                                                  padding: "1px 5px",
                                                }}
                                                className="bg_color"
                                              >
                                                <span>
                                                  {value?.submissionCount}
                                                </span>
                                              </div>
                                            )}
                                            <Tooltip
                                              hasArrow
                                              label="Submission"
                                              bg="gray.300"
                                              color="black"
                                            >
                                              <button
                                                className="note_btn"
                                                style={{ color: "green" }}
                                                onClick={() => {
                                                  if (
                                                    value?.submissionCount !== 0
                                                  ) {
                                                    window.open(
                                                      `/details/jobpostview/${value._id}?i=2`,
                                                      "_blank"
                                                    );
                                                  } else {
                                                    toast.warn(
                                                      "No submission yet",
                                                      {
                                                        position:
                                                          toast.POSITION
                                                            .TOP_RIGHT,
                                                      }
                                                    );
                                                  }
                                                }}
                                              >
                                                S
                                              </button>
                                            </Tooltip>
                                          </div>
                                        </Box>
                                      </TableCell>

                                      <TableCell
                                        style={{
                                          fontWeight: "bold",
                                        }}
                                        className="nowrap_content"
                                      >
                                        <Link
                                          to={
                                            `/details/jobpostview/${value._id}`
                                            // moduleData.view == "none" ||
                                            // (moduleData?.view == "ownrecords" &&
                                            //   value?.job_ownerName?._id !==
                                            //     userId)
                                            //   ? "/admin/jobpost"
                                            //   : `/details/jobpostview/${value._id}`
                                          }
                                          target="_blank"
                                        >
                                          <span>
                                            {!value?.uniqueJobId
                                              ? "N/A"
                                              : `TKJ-${value?.uniqueJobId}`}
                                          </span>
                                        </Link>
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          fontWeight: "bold",
                                        }}
                                        className="nowrap_content"
                                      >
                                        <Link
                                          to={`/details/jobpostview/${value._id}`}
                                          target="_blank"
                                        >
                                          <span>
                                            {!value?.jobtitle
                                              ? "N/A"
                                              : value?.jobtitle}
                                          </span>
                                        </Link>
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        <Link
                                          to={
                                            cookie.role == "Admin" ||
                                            cookie.role == "Client"
                                              ? `/details/accountview/${value?.clientId?._id}`
                                              : "/admin/jobpost"
                                          }
                                          target="_blank"
                                        >
                                          {!value?.clientId?.accountName
                                            ? "N/A"
                                            : value?.clientId?.accountName}
                                        </Link>
                                      </TableCell>
                                     
                                        <TableCell className="nowrap_content">
                                       <Tooltip
                                            label={
                                              value?.branch?.[0]
                                                ?.branchName ?? "N/A"
                                            }
                                          >
                                            <Text
                                              noOfLine={1}
                                              width="160px"
                                              textOverflow="ellipsis"
                                            >
                                              {value?.branch?.[0]
                                                ?.branchName
                                                ? value?.branch?.[0]?.branchName.slice(
                                                    0,
                                                    20
                                                  ) +
                                                  (value?.branch?.[0]
                                                    ?.branchName.length > 20
                                                    ? "..."
                                                    : "")
                                                : "N/A"}
                                            </Text>
                                          </Tooltip>
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.clientContactName_data
                                          ?.accountOwnerName
                                          ? "N/A"
                                          : value?.clientContactName_data
                                              ?.accountOwnerName}
                                      </TableCell>

                                      <TableCell className="nowrap_content">
                                        {!value?.city ? "N/A" : value?.city}
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.state ? "N/A" : value?.state}
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.status ? "N/A" : value?.status}{" "}
                                        <Tooltip
                                          hasArrow
                                          label="Change Status"
                                          bg="gray.300"
                                          color="black"
                                        >
                                          <EditIcon
                                            style={{
                                              fontSize: "15px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              handleEditStatusShow(
                                                setJobpost(value),
                                                setJobId(value._id)
                                              );
                                            }}
                                          />
                                        </Tooltip>
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.job_owener_data
                                          ? "N/A"
                                          : `${value?.job_owener_data?.firstName} ${value?.job_owener_data?.lastName}`}
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.account_manager_data?._id
                                          ? "N/A"
                                          : `${value?.account_manager_data?.firstName} ${value?.account_manager_data?.lastName}`}
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.recruiter_data?._id
                                          ? "N/A"
                                          : `${value?.recruiter_data?.firstName} ${value?.recruiter_data?.lastName}`}
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.teamleader_data?._id
                                          ? "N/A"
                                          : `${value?.teamleader_data?.firstName} ${value?.teamleader_data?.lastName}`}
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.skill ? (
                                          "N/A"
                                        ) : (
                                          <span
                                            title={value.skill}
                                            style={{ cursor: "pointer" }}
                                          >
                                            {value.skill.length > 20
                                              ? `${value.skill.slice(0, 20)}...`
                                              : value.skill}
                                          </span>
                                        )}
                                      </TableCell>
                                      <TableCell className="nowrap_content">
                                        {!value?.created_at_date
                                          ? "N/A"
                                          : new Date(
                                              value?.created_at_date
                                            ).toLocaleDateString()}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </>
                            )}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <CommonPagination
                    rowsPerPage={rowsPerPage}
                    page={page}
                    totalPages={Math.ceil(
                      displayClientJobs?.totalJobPosts / rowsPerPage
                    )}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    count={displayClientJobs?.totalJobPosts || 10}
                  />
                </Paper>
              </div>
              {/* Modal for Add Job post */}
             {ViewPost && <JobAddModal
                setJdLoading={setJdLoading}
                setRecruiters={setRecruiters}
                setSelectedAccountManager={setSelectedAccountManager}
                setSelectedRecruiter={setSelectedRecruiter}
                setSelectedTeamLeader={setSelectedTeamLeader}
                setSelectedTeamD={setSelectedTeamD}
                setJobpost={setJobpost}
                jobBranch={jobBranch}
                setJobBranch={setJobBranch}
                
                jdLoading={jdLoading}
                getCurrentLoggedInUserName={getCurrentLoggedInUserName}
                industries={industries}
                recruiters={recruiters}
                selectedRecruiter={selectedRecruiter}
                selectedTeamD={selectedTeamD}
                selectedTeamLeader={selectedTeamLeader}
                alluserTeams={alluserTeams}
                selectedAccountManager={selectedAccountManager}
                selectedCity={selectedCity}
                City={City}
                selectedState={selectedState}
                selectedCountry={selectedCountry}
                handleInputs={handleInputs}
                jobpost={jobpost}
                contacts={[]}
                setSelectedState={setSelectedState}
                setSelectedCity={setSelectedCity}
                setSelectedCountry={setSelectedCountry}
                setSelectedClientContactName={setSelectedClientContactName}
                selectedClientContactName={selectedClientContactName}
                handleChange={() => {}}
                options={[]}
                selectedOption={selectedOption}
                formSubmitLoading={false}
                jobLoading={jobLoading}
                ViewPost={ViewPost}
                handlePostClose={handlePostClose}
                formik={formik}
                view={"contactview"}
                viewId={contact.accountId}
              />}
              {/* Modal for Edit Job post */}
             {ViewEdit && <JobAddModal
                setJdLoading={setJdLoading}
                setRecruiters={setRecruiters}
                setSelectedAccountManager={setSelectedAccountManager}
                setSelectedRecruiter={setSelectedRecruiter}
                setSelectedTeamLeader={setSelectedTeamLeader}
                setSelectedTeamD={setSelectedTeamD}
                setJobpost={setJobpost}
                jobBranch={jobBranch}
                setJobBranch={setJobBranch}
                jdLoading={jdLoading}
                getCurrentLoggedInUserName={getCurrentLoggedInUserName}
                industries={industries}
                recruiters={recruiters}
                selectedRecruiter={selectedRecruiter}
                selectedTeamD={selectedTeamD}
                selectedTeamLeader={selectedTeamLeader}
                alluserTeams={alluserTeams}
                selectedAccountManager={selectedAccountManager}
                selectedCity={selectedCity}
                City={City}
                selectedState={selectedState}
                selectedCountry={selectedCountry}
                handleInputs={handleInputs}
                jobpost={jobpost}
                contacts={[]}
                setSelectedState={setSelectedState}
                setSelectedCity={setSelectedCity}
                setSelectedCountry={setSelectedCountry}
                setSelectedClientContactName={setSelectedClientContactName}
                selectedClientContactName={selectedClientContactName}
                handleChange={() => {}}
                options={[]}
                selectedOption={selectedOption}
                formSubmitLoading={false}
                jobLoading={jobLoading}
                ViewPost={ViewEdit}
                handlePostClose={handleEditClose}
                formik={editFormik}
                view={"contactview"}
                edit={true}
                viewId={contact.accountId}
              />}

              {/* Modal for Delete Job */}
              <DeleteModal
                title={"Delete Job"}
                ViewDelete={deleteJob}
                handleDeleteClose={handleDeleteJobClose}
                handleDelete={handleDelete}
              />
              {/* Modal for Edit Job Status*/}
              <div className="model-box-view">
                <Modal
                  show={ViewEditStatus}
                  onHide={handleEditStatusClose}
                  backdrop="static"
                  closeOnOverlayClick={false}
                  keyboard={false}
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="usertitle">
                      Edit Job Status
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <label>Select Status</label>
                    <select
                      className="form-control"
                      name="status"
                      defaultValue={jobpost.status}
                      onChange={handleInputs}
                    >
                      <option disabled={true} value="">
                        Status
                      </option>
                      <option>Active</option>
                      <option>Deactive</option>
                      <option>On Hold</option>
                      <option>Cancelled</option>
                      <option>Target Date Expired</option>
                    </select>
                  </Modal.Body>
                  <Modal.Footer
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button className="cancel" onClick={handleEditStatusClose}>
                      Cancel
                    </Button>
                    <Button className="btn_bg_color" onClick={handleEditStatus}>
                      Update
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </TabPanel>

            {/* ========== Submission Table ============= */}
            <TabPanel>
              <CommonSubmissionFile
                setSearchBranch={setSearchBranch}
                searchBranch={searchBranch}
                isFilterActiveBranch={isFilterActiveBranch}
                setIsFilterActiveBranch={setIsFilterActiveBranch}
                searchSubmissionId={searchSubmissionId}
                isFilterActiveSubmissionId={isFilterActiveSubmissionId}
                setSearchSubmissionId={setSearchSubmissionId}
                setIsFilterActiveNoticePeriod={setIsFilterActiveNoticePeriod}
                setIsFilterActiveUpdatedBy={setIsFilterActiveUpdatedBy}
                setIsFilterActiveSourceSearch={setIsFilterActiveSourceSearch}
                setIsFilterActiveIndustry={setIsFilterActiveIndustry}
                setIsFilterActiveState={setIsFilterActiveState}
                setIsFilterActiveCity={setIsFilterActiveCity}
                setIsFilterActiveClient={setIsFilterActiveClient}
                setIsFilterActiveOwner={setIsFilterActiveOwner}
                setIsFilterActiveStatus={setIsFilterActiveStatus}
                setIsFilterActiveExperience={setIsFilterActiveExperience}
                displaysubmissions={displayAppliedJob}
                Searchicon={Searchicon}
                searchAllfields={searchAllfields}
                setSearchAllfields={setSearchAllfields}
                moduleData={moduleData}
                handleCreateSubmission={handleCreateSubmission}
                setId={setId}
                handleSubmHeaderOrdersshow={handleSubmHeaderOrdersshow}
                SetIschecked={SetIschecked}
                handleSendMailShow={handleSendMailShow}
                handleOpenModal={handleOpenModal}
                checked={checked}
                handleEditShow={handleEditSubmissionShow}
                setSubmission={setSubmission}
                handleDeleteSubmissionShow={handleDeleteSubmissionShow}
                handleCandidateNoteShow={handleCandidateNoteShow}
                getCandidatNotes={getCandidatNotes}
                SubmissionPreview={SubmissionPreview}
                handleSubmissionPreviewShow={handleSubmissionPreviewShow}
                handleEditSubmissionStatusShow={handleEditSubmissionStatusShow}
                // setChangeStatus={setChangeStatus}
                setOldJobId={setOldJobId}
                page={contactPage}
                rowsPerPage={rowsPerContactPage}
                applicationStatus={applicationStatus}
                loading={loading}
                setLoading={setLoading}
                // changeStatus={changeStatus}
                setNote={setNote}
                note={note}
                submheaderOrders={submheaderOrders}
                submissions={appliedJob}
                setPage={setContactPage}
                setRowsPerPage={setRowsPerContactPage}
                componentName={"all"}
                setSubmissionId={setSubmissionId}
                isClientView={true}
                clientId={contact?.accountName}
                contactId={contact?.accountOwnerName}
                Setcandidatename={Setcandidatename}
                setActiveField={setActiveField}
                activeField={activeField}
                clearFilter={clearFilter}
                searchfname={searchfname}
                setSearchFname={setSearchFname}
                searchlname={searchlname}
                setSearchLname={setSearchLname}
                searchjobt={searchjobt}
                setSearchJobt={setSearchJobt}
                searchstatus={searchstatusSubmission}
                setSearchStatus={setSearchStatusSubmission}
                searchcustomer={searchcustomer}
                setSearchCustomer={setSearchCustomer}
                searchOwnerName={searchOwnerName}
                setSearchOwnerName={setSearchOwnerName}
                searchcandidatectctype={searchcandidatectctype}
                setSearchCandidatectctype={setSearchCandidatectctype}
                searchcandidatectc={searchcandidatectc}
                setSearchCandidatectc={setSearchCandidatectc}
                searchcity={searchcitySubmission}
                setSearchCity={setSearchCitySubmission}
                searchstate={searchState}
                setSearchstate={setSearchstate}
                searchSubmissionDate={searchSubmissionDate}
                setSearchSubmissionDate={setSearchSubmissionDate}
                searchSubmissionUpdateDate={searchSubmissionUpdateDate}
                setSearchSubmissionUpdateDate={setSearchSubmissionUpdateDate}
                searchExpectedCandidateCTC={searchExpectedCandidateCTC}
                setSearchExpectedCandidateCTC={setSearchExpectedCandidateCTC}
                searchExpectedCandidateCTCType={searchExpectedCandidateCTCType}
                setSearchExpectedCandidateCTCType={
                  setSearchExpectedCandidateCTCType
                }
                searchNoticePeriod={searchNoticePeriod}
                setSearchNoticePeriod={setSearchNoticePeriod}
                searchPhone={searchPhone}
                setSearchPhone={setSearchphone}
                searchAddress={searchAddress}
                setSearchAddress={setSearchAddress}
                searchDOB={searchDOB}
                setSearchDOB={setSearchDOB}
                searchAadharCardNumber={searchAadharCardNumber}
                setSearchAadharCardNumber={setSearchAadharCardNumber}
                searchPanCardNumber={searchPanCardNumber}
                setSearchPanCardNumber={setSearchPanCardNumber}
                searchDesignation={searchDesignation}
                setSearchDesignation={setSearchdesignation}
                searchWorkExperience={searchWorkExperience}
                setSearchWorkExperience={setSearchWorkExperience}
                searchEducationDetails={searchEducationDetails}
                setSearchEducationDetails={setSearchEducationDetails}
                searchExperience={searchExperience}
                setSearchExperience={setSearchExperience}
                searchGender={searchGender}
                setSearchGender={setSearchGender}
                searchInterviewScheduleDate={searchInterviewScheduleDate}
                setSearchInterviewScheduleDate={setSearchInterviewScheduleDate}
                searchInterviewScheduleTime={searchInterviewScheduleTime}
                setSearchInterviewScheduleTime={setSearchInterviewScheduleTime}
                searchInterviewScheduleLocation={
                  searchInterviewScheduleLocation
                }
                setSearchInterviewScheduleLocation={
                  setSearchInterviewScheduleLocation
                }
                searchInterviewScheduleLink={searchInterviewScheduleLink}
                setSearchInterviewScheduleLink={setSearchInterviewScheduleLink}
                searchJoinDate={searchJoinDate}
                setSearchJoinDate={setSearchJoinDate}
                searchSubmissionBy={searchSubmissionBy}
                setSearchSubmissionBy={setSearchSubmissionBy}
                searchEmail={searchEmail}
                setSearchEmail={setSearchemail}
                searchContactName={searchContactName}
                setSearchContactName={setSearchContactName}
                searchActualCTC={searchActualCTC}
                setSearchActualCTC={setSearchActualCTC}
                searchOfferCTC={searchOfferCTC}
                setSearchOfferCTC={setSearchOfferCTC}
                searchExpectedJoinDate={searchExpectedJoinDate}
                setSearchExpectedJoinDate={setSearchExpectedJoinDate}
                searchUpdatedBy={searchUpdatedBy}
                setSearchUpdatedBy={setSearchUpdatedBy}
                searchFullName={searchFullName}
                setSearchFullName={setSearchFullName}
                isFilterActiveFname={isFilterActiveFname}
                isFilterActiveFullName={isFilterActiveFullName}
                isFilterActiveUpdatedBy={isFilterActiveUpdatedBy}
                isFilterActiveExpectedJoinDate={isFilterActiveExpectedJoinDate}
                isFilterActiveUpdatedDate={isFilterActiveUpdatedDate}
                isFilterActiveOfferCTC={isFilterActiveOfferCTC}
                isFilterActiveActualCTC={isFilterActiveActualCTC}
                isFilterActiveEmail={isFilterActiveEmail}
                isFilterActiveSubmissionBy={isFilterActiveSubmissionBy}
                isFilterActiveJoinDate={isFilterActiveJoinDate}
                isFilterActiveInterviewScheduleLink={
                  isFilterActiveInterviewScheduleLink
                }
                isFilterActiveInterviewScheduleLocation={
                  isFilterActiveInterviewScheduleLocation
                }
                isFilterActiveInterviewScheduleTime={
                  isFilterActiveInterviewScheduleTime
                }
                isFilterActiveInterviewScheduleDate={
                  isFilterActiveInterviewScheduleDate
                }
                isFilterActiveGender={isFilterActiveGender}
                isFilterActiveExperience={isFilterActiveExperience}
                isFilterActiveEducationDetails={isFilterActiveEducationDetails}
                isFilterActiveWorkExperience={isFilterActiveWorkExperience}
                isFilterActiveDesignation={isFilterActiveDesignation}
                isFilterActivePanCardNumber={isFilterActivePanCardNumber}
                isFilterActiveAadharCardNumber={isFilterActiveAadharCardNumber}
                isFilterActiveDOB={isFilterActiveDOB}
                isFilterActiveAddress={isFilterActiveAddress}
                isFilterActivePhone={isFilterActivePhone}
                isFilterActiveNoticePeriod={isFilterActiveNoticePeriod}
                isFilterActivEexpectedCtctype={isFilterActivEexpectedCtctype}
                isFilterActiveExpectedCtc={isFilterActiveExpectedCtc}
                isFilterActiveLname={isFilterActiveLname}
                isFilterActiveJobt={isFilterActiveJobt}
                isFilterActiveStatus={isFilterActiveStatusSubmission}
                isFilterActiveClient={isFilterActiveClient}
                isFilterActiveOwner={isFilterActiveOwner}
                isFilterActiveCtctype={isFilterActiveCtctype}
                isFilterActiveCtc={isFilterActiveCtc}
                isFilterActiveCity={isFilterActiveCitySubmission}
                isFilterActiveState={isFilterActiveStateSubmission}
                isFilterActiveDate={isFilterActiveDate}
                isFilterActiveContactName={isFilterActiveContactName}
                setIsFilterActiveSubmissionBy={setIsFilterActiveSubmissionBy}
                filterData={filterData}
                setMySubmissionValue={setMySubmissionValue}
                mySubmissionValue={mySubmissionValue}
                handleFilterAllFieldStep={handleFilterAllFieldSteps}
                popoverVisible={popoverVisibleSubmission}
                setPopoverVisible={setPopoverVisibleSubmission}
                handlePopOverClose={handlePopOverCloseSubmission}
                industries={industries}
                setSearchIndustry={setSearchIndustry}
                searchIndustry={searchIndustry}
                isFilterActiveIndustry={isFilterActiveIndustry}
                handleActivitySubmit={handleCandidateActivitySubmit}
                searchInterviewRescheduleDate={searchInterviewRescheduleDate}
                setSearchInterviewRescheduleDate={
                  setSearchInterviewRescheduleDate
                }
                isFilterActiveInterviewRescheduleDate={
                  isFilterActiveInterviewRescheduleDate
                }
                searchTestRescheduleDate={searchTestRescheduleDate}
                setSearchTestRescheduleDate={setSearchTestRescheduleDate}
                isFilterActiveTestRescheduleDate={
                  isFilterActiveTestRescheduleDate
                }
                searchBackoutDate={searchBackoutDate}
                setSearchBackoutDate={setSearchBackoutDate}
                isFilterActiveBackoutDate={isFilterActiveBackoutDate}
                setSearchSourceData={setSearchSourceData}
                searchSourceData={searchSourceData}
                isFilterActiveSourceSearch={isFilterActiveSourceSearch}
              />

              <CustomizeColumns
                ViewSubmheaderOrders={ViewSubmheaderOrders}
                handleSubmHeaderOrdersClose={handleSubmHeaderOrdersClose}
                onDragEnd={onDragEnd}
                displaySubmheaderOrders={displaySubmheaderOrders}
                defaultDisplaySubmHeaderOrders={defaultDisplaySubmHeaderOrders}
                handleCheckboxChange={handleCheckboxChange}
                handleApplyClick={handleApplyClick}
              />

              {/* Modal for Candidate Note creation */}
              <NoteSubmissionModel
                candidateNote={candidateNote}
                handleCandidateNoteClose={handleCandidateNoteClose}
                searchNote={searchNote}
                getnotes={getnotes}
                setSearchNote={setSearchNote}
                setNote={setNote}
                note={note}
                setGetNotes={setGetNotes}
                // getJobpostdata={getAppliedJobdata}
                getJobpostdata={handleFilterAllFieldStep}
                page={page}
                rowsPerPage={rowsPerPage}
                setNotesLoading={setNotesLoading}
                notesLoading={notesLoading}
              />

              <CustomizeColumns
                ViewSubmheaderOrders={isOpen}
                handleSubmHeaderOrdersClose={handleCloseModal}
                onDragEnd={onDragEnd}
                displaySubmheaderOrders={displaySubmheaderOrders}
                defaultDisplaySubmHeaderOrders={defaultDisplaySubmHeaderOrders}
                handleCheckboxChange={handleCheckboxChange}
                handleApplyClick={exportSubmissions}
                candidates={displayAppliedJob}
                filename={filename}
                Changeoption={handleApplyClick}
              />

              {/* Modal for Search Job */}
              <SearchJobModel
                searchJobModel={searchJob}
                setSearchJobId={setSearchJobId}
                searchJobId={searchJobId}
                handleCreateSubmissionClose={handleCreateSubmissionClose}
                searchjob={searchAllfields}
                setSearchJob={setSearchAllfields}
                filterJobpostData={handleFilterAllFieldStep}
                loading={jobLoading}
                jobposts={displayClientJobs}
                setSubmission={setSubmission}
                setJobScreeningId={setJobScreeningId}
                Setjobtitle={Setjobtitle}
                handleSubmitSubmissionShow={handleSearchCandidateShow}
                rowsPerSubmissionPage={rowsPerSubmissionPage}
                submissionpage={submissionpage}
                handleChangeSubmissionPage={handleChangeSubmissionPage}
                handleChangeRowsPerSubmissionPage={
                  handleChangeRowsPerSubmissionPage
                }
                // getJobpostdata={getContactJobsdata}
                submission={submission}
                jobtitle={jobtitle}
                clearFilter={clearJobFilter}
                jobSearchActiveField={jobSearchActiveField}
                setJobSearchActiveField={setJobSearchActiveField}
                searchJobTitle={searchjobtitle}
                setSearchJobTitle={setSearchJobtitle}
                searchJobCity={searchcity}
                setSearchJobCity={setSearchCity}
                setSearchJobBranch={setSearchJobBranch}
                searchJobBranch={searchJobBranch}
                setSearchJobOwner={setSearchJobOwner}
                searchJobOwner={searchJobOwner}
              />

              {/* Modal for Search Candidate */}
              <SearchCandidateModel
                serachCandidateId={uniqueCandidateId}
                setSerachCandidateId={setUniqueCandidateId}
                searchCandidateModelShow={searchCandidateModelShow}
                handleSearchCandidateClose={handleSearchCandidateClose}
                searchcandidate={searchcandidate}
                setSearchcandidate={setSearchcandidate}
                filterCandidateData={filterCandidateData}
                loading={searchCandidateLoading}
                candidates={candidates}
                setSubmission={setSubmission}
                submission={submission}
                Setcandidatename={Setcandidatename}
                candidatename={candidatename}
                handleSubmitSubmissionShow={handleSubmitSubmissionShow}
                rowsPerCandidateSubmissionPage={rowsPerCandidateSubmissionPage}
                candidatesubmissionpage={candidatesubmissionpage}
                handleChangeCandidateSubmissionPage={
                  handleChangeCandidateSubmissionPage
                }
                handleChangeRowsPerCandidateSubmissionPage={
                  handleChangeRowsPerCandidateSubmissionPage
                }
                setSearchCandidateName={setSearchCandidateName}
                searchCandidateName={searchCandidateName}
                setSearchCandidateDesignation={setSearchCandidateDesignation}
                searchCandidateDesignation={searchCandidateDesignation}
                setSearchCandidateCity={setSearchCandidateCity}
                searchCandidateCity={searchCandidateCity}
                setCandidateSearchActiveField={setCandidateSearchActiveField}
                candidateSearchActiveField={candidateSearchActiveField}
                clearCandidateSearchFilter={clearCandidateSearchFilter}
                setSearchCandidateOwnerName={setSearchCandidateOwnerName}
                searchCandidateOwnerName={searchCandidateOwnerName}
              />
              {/* Modal for Submit Submission */}
              {/* Modal for Edit Submission */}

              <Submissionform
                handleInputs={handleInputs}
                show={true}
                handleActivitySubmit={handleActivitySubmit}
                applicationStatus={applicationStatus}
                candidateStatus={submission?.status}
                saveFile={saveFile}
                handleSubmitSubmissionClose={handleSubmitSubmissionClose}
                submitSubmission={submitSubmission}
                submission={submission}
                setSubmission={setSubmission}
                handleCreateSubmissionClose={handleCreateSubmissionClose}
                handleSearchCandidateClose={handleSearchCandidateClose}
                // getAllSubmissiondata={getAppliedJobdata}
                getAllSubmissiondata={handleFilterAllFieldSteps}
                candidatename={candidatename}
                jobtitle={jobtitle}
                id={Id}
                setId={setId}
                handleCandidateActivitySubmit={handleCandidateActivitySubmit}
                handleEditShow={handleEditShow}
                editSubmission={editSubmission}
                handleEditClose={handleEditClose}
                handleAppliedJobEmailSend={handleAppliedJobEmailSend}
                handleAppliedJobClientEmailSend={
                  handleAppliedJobClientEmailSend
                }
                component="contact"
                handleResumeMatching={handleResumeMatching}
                matchingSkills={matchingSkills}
                ParsedSkills={ParsedSkills}
                missingSkills={missingSkills}
                parseResumeConclusion={parseResumeConclusion}
                loadingResumeScreening={loadingResumeScreening}
                parsePercentage={parsePercentage}
                parseAge={parseAge}
                router={router}
                // handleUpdateStatus={handleUpdateStatus}
                clearFilter={clearJobFilter}
                // getCandidatedata={getCandidatedata}
                getCandidatedata={handleFilterAllFieldStep}
              />

              {/* Modal for Delete Submission */}
              <DeleteModal
                ViewDelete={deleteSubmission}
                title={"Delete Submission"}
                handleDeleteClose={handleDeleteSubmissionClose}
                handleDelete={handleDeleteSubmission}
              />

              {/* Modal for Edit Submission Status*/}

              <EditSubmissionStatusModel
                editSubmissionStatus={editSubmissionStatus}
                handleEditSubmissionStatusClose={
                  handleEditSubmissionStatusClose
                }
                submission={submission}
                handleInputs={handleInputs}
                applicationStatus={applicationStatus}
                handleUpdateStatus={handleEditSubmissionStatus}
                handleEditShow={handleEditSubmissionShow}
                SetEditSubmissionStatus={SetEditSubmissionStatus}
              />

              {/* Modal for Submission Preview */}
              <ResumePreviewModal
                preview={submissionPreview}
                handlePreviewClose={handleSubmissionPreviewClose}
                objectURL={objectURL?.filePath}
                firstName={submission?.candidateId?.firstName}
                lastName={submission?.candidateId?.lastName}
                phone={submission?.candidateId?.phone}
                email={submission?.candidateId?.email}
                fileName={submission?.fileName}
                resumeFilePath={""}
                action={() => {
                  () => {
                    handleCandidateNoteShow();
                    setNote({
                      ...note,
                      candidateId: submission?.candidateId?._id,
                    });
                    getCandidatNotes(submission?.candidateId?._id);
                  };
                }}
              />
              {/* <div className="model-box-view">
                <Modal
                  show={submissionPreview}
                  onHide={handleSubmissionPreviewClose}
                  backdrop="static"
                  keyboard={false}
                  size="xl"
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="usertitle">
                      Resume Preview
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Container>
                      <Row>
                        <Col lg={8} md={6} sm={6}>
                          {!objectURL ? (
                            <>
                              <div className="resume_ld">
                                <Loader />
                              </div>
                            </>
                          ) : objectURL === "no-resume" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                              }}
                            >
                              <img
                                src={NotFound}
                                alt="NotFound"
                                style={{ width: "16rem" }}
                              />
                              <p>No Resume Found! Please try again....</p>
                            </div>
                          ) : (
                            <div
                              style={{
                                borderRight: "1px solid rgb(222, 226, 230)",
                                paddingRight: "18px",
                              }}
                            >
                              {(() => {
                                const isObjectUrlDoc =
                                  objectURL &&
                                  (objectURL?.filePath
                                    .toLowerCase()
                                    .endsWith(".doc") ||
                                    objectURL?.filePath
                                      .toLowerCase()
                                      .endsWith(".docx"));
                                if (isObjectUrlDoc) {
                                  const filePath = objectURL
                                    ? `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`
                                    : resumeFilePath;

                                  return (
                                    <>
                                      <Box
                                        style={{
                                          overflow: "auto",
                                          userSelect: "text",
                                          height: "85vh",
                                          position: "relative",
                                        }}
                                      >
                                        <FileViewer
                                          fileType={
                                            objectURL?.filePath
                                              .toLowerCase()
                                              .endsWith(".doc")
                                              ? "doc"
                                              : "docx"
                                          }
                                          filePath={filePath}
                                          onError={(e) => {
                                            console.error(
                                              "FileViewer Error:",
                                              e
                                            );
                                            // setViewerError(e);
                                          }}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                        />
                                      </Box>
                                    </>
                                  );
                                }

                                // Use iframe for other file types
                                return (
                                  <>
                                    {objectURL && (
                                      <iframe
                                        src={`https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`}
                                        width="100%"
                                        height="800px"
                                        title="PDF Viewer"
                                        frameBorder="0"
                                        style={{ border: "none" }}
                                      />
                                    )}
                                  </>
                                );
                              })()}
                            </div>
                          )}
                        </Col>
                        <Col lg={4} md={6} sm={6}>
                          <div className="resume_pr">
                            <div>
                              <Button
                                className="bg_color"
                                style={{
                                  color: "white",
                                  border: "1px solid #d7d7d7",
                                  fontWeight: "500",
                                  letterSpacing: "1px",
                                  fontSize: "14px",
                                }}
                                onClick={() => {
                                  handleCandidateNoteShow();
                                  setNote({
                                    ...note,
                                    candidateId: submission?.candidateId?._id,
                                  });
                                  getCandidatNotes(
                                    submission?.candidateId?._id
                                  );
                                }}
                              >
                                Notes
                              </Button>
                              <Heading
                                size="md"
                                fontWeight="bold"
                                letterSpacing="tight"
                              >
                                {!submission?.candidateId?.firstName
                                  ? "N/A"
                                  : submission?.candidateId?.firstName}{" "}
                                {!submission?.candidateId?.lastName
                                  ? "N/A"
                                  : submission?.candidateId?.lastName}
                              </Heading>
                              <Text
                                color={useColorModeValue(
                                  "gray.600",
                                  "gray.400"
                                )}
                              >
                                <CallOutlinedIcon
                                  style={{ fontSize: "medium" }}
                                />{" "}
                                {!submission?.candidateId?.phone
                                  ? "N/A"
                                  : submission?.candidateId?.phone}
                              </Text>
                              <Text
                                color={useColorModeValue(
                                  "gray.600",
                                  "gray.400"
                                )}
                              >
                                <EmailOutlinedIcon
                                  style={{ fontSize: "medium" }}
                                />{" "}
                                {!submission?.candidateId?.email
                                  ? "N/A"
                                  : submission?.candidateId?.email}
                              </Text>
                            </div>
                            <div>
                              <Tooltip
                                hasArrow
                                label="Download Resume"
                                bg="gray.300"
                                color="black"
                              >
                                <a
                                  href={
                                    objectURL === "no-resume"
                                      ? "#"
                                      : `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`
                                  }
                                  download={`https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`}
                                  onClick={(e) => {
                                    if (
                                      objectURL?.filePath
                                        .toLowerCase()
                                        .endsWith(".pdf")
                                    ) {
                                      e.preventDefault();
                                      fetch(
                                        `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`
                                      )
                                        .then((response) => response.blob())
                                        .then((blob) => {
                                          const url =
                                            window.URL.createObjectURL(blob);
                                          const link =
                                            document.createElement("a");
                                          link.href = url;
                                          link.download =
                                            objectURL?.filePath
                                              .split("/")
                                              .pop() || "download.pdf";
                                          document.body.appendChild(link);
                                          link.click();
                                          link.remove();
                                          window.URL.revokeObjectURL(url);
                                        });
                                    }
                                  }}
                                  rel="noopener noreferrer"
                                >
                                  <button
                                    class="btn bg-white border rounded mb-2 text-break"
                                    style={{ width: "100%", height: "auto" }}
                                  >
                                    {!submission?.fileName
                                      ? "N/A"
                                      : submission?.fileName}{" "}
                                    <VerticalAlignBottomIcon
                                      style={{ color: "grey" }}
                                    />
                                  </button>
                                </a>
                              </Tooltip>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="cancel"
                      onClick={handleSubmissionPreviewClose}
                    >
                      Cancel
                    </button>
                  </Modal.Footer>
                </Modal>
              </div> */}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
      <NoteModel
        jobNote={jobNote}
        handleJobNoteClose={handleJobNoteClose}
        searchNote={searchNote}
        getnotes={getnotes}
        setSearchNote={setSearchNote}
        setNote={setNote}
        note={note}
        setGetNotes={setGetNotes}
        getJobpostdata={handleFilterAllFieldStep}
        submissionData={contact}
        setNotesLoading={setNotesLoading}
        notesLoading={notesLoading}
        page={page}
        rowPerPage={rowsPerPage}
      />
    </Box>
  );
}

export default Contactview;
